// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  /* Reads the design-system token (redesign.css, imported after this file, so
     its :root definition wins) with a literal fallback if that file is ever
     absent. This previously named 'Inter', which index.html never loaded --
     so the dashboard has in fact been rendering in the system UI font. */
  font-family: var(
    --font-sans,
    "Poppins",
    system-ui,
    -apple-system,
    "Segoe UI",
    Roboto,
    sans-serif
  );
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

/* Split Layout Container */
.auth-layout {
  display: flex;
  min-height: 100vh;
}

/* Left Side - 3D Illustration */
.auth-left {
  flex: 1 1;
  /* background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 30%, #a855f7 60%, #c084fc 100%); */
  position: relative;
  /* overflow: hidden; */
}
.auth-left img {
  float: left;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.crypto-scene {
  position: relative;
  width: 100%;
  height: 100%;
  perspective: 1000px;
  transform-style: preserve-3d;
}

/* Gradient blobs for background depth */
.gradient-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.6;
}

.blob-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, #06b6d4 0%, transparent 70%);
  top: -10%;
  right: -10%;
  animation: blobFloat1 15s ease-in-out infinite;
}

.blob-2 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, #8b5cf6 0%, transparent 70%);
  bottom: 10%;
  left: -5%;
  animation: blobFloat2 18s ease-in-out infinite;
}

.blob-3 {
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, #ec4899 0%, transparent 70%);
  top: 40%;
  right: 20%;
  animation: blobFloat3 12s ease-in-out infinite;
}

@keyframes blobFloat1 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  33% {
    transform: translate(-30px, 20px) scale(1.1);
  }

  66% {
    transform: translate(20px, -30px) scale(0.9);
  }
}

@keyframes blobFloat2 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(40px, -20px) scale(1.15);
  }
}

@keyframes blobFloat3 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(-25px, 25px) scale(1.1);
  }
}

/* 3D Crypto Coins */
.crypto-coin {
  position: absolute;
  transform-style: preserve-3d;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

.coin-inner {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
}

.coin-face {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backface-visibility: hidden;
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.3),
    inset 0 2px 10px rgba(255, 255, 255, 0.3);
}

.coin-front {
  transform: rotateY(0deg);
}

.coin-front span {
  font-size: 24px;
  font-weight: bold;
  color: white;
}

.coin-front svg {
  width: 60%;
  height: 60%;
}

/* Ethereum Coin */
.eth-coin {
  width: 70px;
  height: 70px;
  top: 12%;
  left: 15%;
  animation: floatEth3D 8s infinite;
}

.eth-coin .coin-face {
  background: linear-gradient(145deg, #627eea 0%, #3c4fd1 100%);
  border: 3px solid rgba(255, 255, 255, 0.2);
}

@keyframes floatEth3D {
  0%,
  100% {
    transform: translateY(0) rotateX(10deg) rotateY(0deg);
  }

  25% {
    transform: translateY(-20px) rotateX(20deg) rotateY(15deg);
  }

  50% {
    transform: translateY(-10px) rotateX(5deg) rotateY(30deg);
  }

  75% {
    transform: translateY(-25px) rotateX(15deg) rotateY(15deg);
  }
}

/* Bitcoin Coin */
.btc-coin {
  width: 55px;
  height: 55px;
  top: 8%;
  right: 25%;
  animation: floatBtc3D 9s infinite;
}

.btc-coin .coin-face {
  background: linear-gradient(145deg, #f7931a 0%, #c77700 100%);
  border: 3px solid rgba(255, 255, 255, 0.25);
}

.btc-coin .coin-front span {
  font-size: 28px;
}

@keyframes floatBtc3D {
  0%,
  100% {
    transform: translateY(0) rotateX(5deg) rotateY(0deg);
  }

  30% {
    transform: translateY(-15px) rotateX(-10deg) rotateY(-20deg);
  }

  60% {
    transform: translateY(-25px) rotateX(10deg) rotateY(10deg);
  }
}

/* USDT Coin */
.usdt-coin {
  width: 50px;
  height: 50px;
  top: 28%;
  left: 5%;
  animation: floatUsdt3D 7s infinite;
}

.usdt-coin .coin-face {
  background: linear-gradient(145deg, #26a17b 0%, #1a7a5c 100%);
  border: 3px solid rgba(255, 255, 255, 0.2);
}

.usdt-coin .coin-front span {
  font-size: 22px;
}

@keyframes floatUsdt3D {
  0%,
  100% {
    transform: translateY(0) rotateX(0deg) rotateY(0deg) rotateZ(0deg);
  }

  50% {
    transform: translateY(-18px) rotateX(15deg) rotateY(25deg) rotateZ(5deg);
  }
}

/* Solana Coin */
.sol-coin {
  width: 60px;
  height: 60px;
  top: 45%;
  left: 8%;
  animation: floatSol3D 10s infinite;
}

.sol-coin .coin-face {
  background: linear-gradient(145deg, #9945ff 0%, #14f195 100%);
  border: 3px solid rgba(255, 255, 255, 0.2);
}

@keyframes floatSol3D {
  0%,
  100% {
    transform: translateY(0) rotateX(5deg) rotateY(0deg);
  }

  33% {
    transform: translateY(-22px) rotateX(-15deg) rotateY(20deg);
  }

  66% {
    transform: translateY(-12px) rotateX(10deg) rotateY(-15deg);
  }
}

/* BNB Coin */
.bnb-coin {
  width: 55px;
  height: 55px;
  top: 38%;
  right: 12%;
  animation: floatBnb3D 8.5s infinite;
}

.bnb-coin .coin-face {
  background: linear-gradient(145deg, #f3ba2f 0%, #c99a00 100%);
  border: 3px solid rgba(255, 255, 255, 0.25);
}

@keyframes floatBnb3D {
  0%,
  100% {
    transform: translateY(0) rotateX(0deg) rotateY(0deg);
  }

  40% {
    transform: translateY(-20px) rotateX(20deg) rotateY(-25deg);
  }

  80% {
    transform: translateY(-10px) rotateX(-10deg) rotateY(15deg);
  }
}

/* Matic/Polygon Coin */
.matic-coin {
  width: 50px;
  height: 50px;
  top: 18%;
  left: 35%;
  animation: floatMatic3D 9.5s infinite;
}

.matic-coin .coin-face {
  background: linear-gradient(145deg, #8247e5 0%, #5a2eb8 100%);
  border: 3px solid rgba(255, 255, 255, 0.2);
}

@keyframes floatMatic3D {
  0%,
  100% {
    transform: translateY(0) rotateX(10deg) rotateY(5deg);
  }

  50% {
    transform: translateY(-30px) rotateX(-5deg) rotateY(-20deg);
  }
}

/* Red/Orange Coin (like in screenshot) */
.red-coin {
  width: 80px;
  height: 40px;
  top: 40%;
  right: 28%;
  animation: floatRed3D 7.5s infinite;
}

.red-coin .coin-face {
  background: linear-gradient(145deg, #ef4444 0%, #b91c1c 100%);
  border: 3px solid rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  transform: rotateX(60deg);
}

@keyframes floatRed3D {
  0%,
  100% {
    transform: translateY(0) rotateX(60deg) rotateZ(0deg);
  }

  50% {
    transform: translateY(-15px) rotateX(70deg) rotateZ(10deg);
  }
}

/* Avalanche Coin */
.avax-coin {
  width: 55px;
  height: 55px;
  bottom: 20%;
  right: 18%;
  animation: floatAvax3D 8s infinite;
}

.avax-coin .coin-face {
  background: linear-gradient(145deg, #e84142 0%, #b52f30 100%);
  border: 3px solid rgba(255, 255, 255, 0.2);
}

@keyframes floatAvax3D {
  0%,
  100% {
    transform: translateY(0) rotateX(5deg) rotateY(0deg);
  }

  35% {
    transform: translateY(-18px) rotateX(-10deg) rotateY(20deg);
  }

  70% {
    transform: translateY(-8px) rotateX(15deg) rotateY(-10deg);
  }
}

/* Stacked Coins Platform */
.coin-stack {
  position: absolute;
  bottom: 18%;
  left: 12%;
  transform-style: preserve-3d;
  animation: stackFloat 6s ease-in-out infinite;
}

.stack-coin {
  width: 70px;
  height: 20px;
  border-radius: 35px;
  position: absolute;
  transform: rotateX(60deg);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.stack-1 {
  background: linear-gradient(90deg, #8b5cf6 0%, #6d28d9 100%);
  bottom: 0;
}

.stack-2 {
  background: linear-gradient(90deg, #a78bfa 0%, #7c3aed 100%);
  bottom: 8px;
}

.stack-3 {
  background: linear-gradient(90deg, #c4b5fd 0%, #8b5cf6 100%);
  bottom: 16px;
}

@keyframes stackFloat {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

/* Chain/Link Icon */
.chain-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 45%;
  animation: chainFloat 7s ease-in-out infinite;
  opacity: 0.8;
}

.chain-icon svg {
  width: 100%;
  height: 100%;
}

@keyframes chainFloat {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }

  50% {
    transform: translateY(-15px) rotate(10deg);
  }
}

/* Central Platform */
.central-platform {
  position: absolute;
  bottom: 25%;
  left: 50%;
  transform: translateX(-50%);
  transform-style: preserve-3d;
  animation: platformFloat 5s ease-in-out infinite;
}

.platform-3d {
  position: relative;
  transform-style: preserve-3d;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.platform-top {
  width: 160px;
  height: 80px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.25) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
  border-radius: 80px / 40px;
  transform: rotateX(60deg);
  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.3),
    inset 0 2px 10px rgba(255, 255, 255, 0.3);
}

.platform-side {
  width: 160px;
  height: 30px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.05) 100%
  );
  border-radius: 0 0 80px 80px / 0 0 20px 20px;
  position: absolute;
  top: 35px;
  transform-origin: top;
  transform: rotateX(-30deg);
}

.maxel-logo {
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
  width: 70px;
  height: 70px;
  background: linear-gradient(145deg, #1a1a2e 0%, #0f0f1a 100%);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 15px 35px rgba(0, 0, 0, 0.4),
    0 5px 15px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  animation: logoGlow 4s ease-in-out infinite;
}

.maxel-logo span {
  font-size: 32px;
  font-weight: bold;
  color: white;
  text-shadow: 0 0 10px rgba(139, 92, 246, 0.5);
}

@keyframes platformFloat {
  0%,
  100% {
    transform: translateX(-50%) translateY(0);
  }

  50% {
    transform: translateX(-50%) translateY(-12px);
  }
}

@keyframes logoGlow {
  0%,
  100% {
    box-shadow:
      0 15px 35px rgba(0, 0, 0, 0.4),
      0 5px 15px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.1),
      0 0 20px rgba(139, 92, 246, 0);
  }

  50% {
    box-shadow:
      0 15px 35px rgba(0, 0, 0, 0.4),
      0 5px 15px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.1),
      0 0 40px rgba(139, 92, 246, 0.4);
  }
}

/* Floating Particles */
.particle {
  position: absolute;
  width: 6px;
  height: 6px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

.particle-1 {
  top: 8%;
  left: 25%;
  animation: particleFloat 4s ease-in-out infinite;
}

.particle-2 {
  top: 15%;
  right: 15%;
  animation: particleFloat 5s ease-in-out infinite 0.5s;
}

.particle-3 {
  top: 55%;
  left: 3%;
  animation: particleFloat 4.5s ease-in-out infinite 1s;
}

.particle-4 {
  bottom: 30%;
  left: 35%;
  animation: particleFloat 5.5s ease-in-out infinite 1.5s;
}

.particle-5 {
  bottom: 15%;
  right: 25%;
  animation: particleFloat 4s ease-in-out infinite 2s;
}

.particle-6 {
  top: 35%;
  left: 50%;
  animation: particleFloat 6s ease-in-out infinite 0.8s;
}

.particle-7 {
  top: 22%;
  right: 35%;
  animation: particleFloat 4.5s ease-in-out infinite 1.2s;
}

.particle-8 {
  bottom: 45%;
  right: 8%;
  animation: particleFloat 5s ease-in-out infinite 0.3s;
}

@keyframes particleFloat {
  0%,
  100% {
    opacity: 0.4;
    transform: translateY(0) scale(1);
  }

  50% {
    opacity: 1;
    transform: translateY(-20px) scale(1.5);
  }
}

/* Right Side - Form */
.auth-right {
  flex: 1 1;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.auth-form-container {
  width: 100%;
  max-width: 420px;
}

/* Icon at top */
.auth-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #f3e8ff, #e9d5ff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.auth-icon svg {
  width: 40px;
  height: 40px;
  color: #8b5cf6;
}

.auth-icon-inner {
  font-size: 32px;
}

/* Title */
.auth-title {
  text-align: center;
  margin-bottom: 32px;
}

.auth-title h2 {
  color: #1a1a2e;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
  line-height: 1.3;
}

.auth-title p {
  color: #6b7280;
  font-size: 14px;
}

/* Form Elements */
.form-row {
  display: flex;
  gap: 12px;
}

.form-row .form-group {
  flex: 1 1;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
}

.form-group input {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 15px;
  transition: all 0.2s;
  background: #f9fafb;
  font-family: var(--iv-sans);
}

.form-group input:focus {
  outline: none;
  border-color: #8b5cf6;
  background: var(--bg-primary);
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.form-group input::placeholder {
  color: #9ca3af;
}

.form-group input.error {
  border-color: #ef4444;
}

.input-wrapper {
  position: relative;
}

.input-wrapper .toggle-password {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  padding: 0;
}

.error-message {
  color: #ef4444;
  font-size: 12px;
  margin-top: 6px;
}

/* Checkbox */
.checkbox-group {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 16px;
}

.checkbox-group input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #8b5cf6;
  margin-top: 2px;
  cursor: pointer;
}

.checkbox-group label {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
  cursor: pointer;
}

.checkbox-group label a {
  color: #8b5cf6;
  text-decoration: none;
}

.checkbox-group label a:hover {
  text-decoration: underline;
}

/* Buttons */
.btn {
  width: 100%;
  padding: 14px 24px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.login-btn {
  width: 100%;
  padding: 14px 24px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  color: white;
}

.btn-primary {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #7c3aed, #6d28d9);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-google {
  background: #ffffff;
  color: #374151;
  border: 1px solid #e5e7eb;
  margin-top: 16px;
}

.btn-google:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

.btn-google img {
  width: 20px;
  height: 20px;
}

/* Divider */
.divider {
  display: flex;
  align-items: center;
  margin: 24px 0;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #e5e7eb;
}

.divider span {
  padding: 0 16px;
  color: #9ca3af;
  font-size: 14px;
}

/* Auth Links */
.auth-links {
  text-align: center;
  margin-top: 24px;
}

.auth-links p {
  color: #6b7280;
  font-size: 14px;
}

.auth-links a {
  color: #8b5cf6;
  font-weight: 600;
  text-decoration: none;
}

.auth-links a:hover {
  text-decoration: underline;
}

/* Alert Messages */
.alert {
  padding: 14px 16px;
  border-radius: 10px;
  margin-bottom: 20px;
  font-size: 14px;
}

.alert-error {
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.alert-success {
  background-color: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

/* OTP Input */
.otp-container {
  text-align: center;
}

.otp-container > p {
  color: #6b7280;
  margin-bottom: 24px;
  font-size: 15px;
  line-height: 1.6;
}

.otp-container .email-highlight {
  color: #8b5cf6;
  font-weight: 600;
}

.otp-input-group {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
}

.otp-input {
  width: 52px;
  height: 58px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #f9fafb;
  transition: all 0.2s;
}

.otp-input:focus {
  outline: none;
  border-color: #8b5cf6;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.resend-otp {
  margin-top: 20px;
}

.resend-otp span {
  color: #6b7280;
  font-size: 14px;
}

.timer {
  color: #8b5cf6;
  font-weight: 600;
}

.btn-link {
  background: none;
  border: none;
  color: #8b5cf6;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
}

.btn-link:hover {
  text-decoration: underline;
}

.back-link {
  display: inline-block;
  margin-top: 20px;
  color: #6b7280;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s;
}

.back-link:hover {
  color: #8b5cf6;
}

/* Loading Spinner */
.loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 0.8s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Dashboard Styles */
.dashboard-container {
  min-height: 100vh;
  background: #f5f5f5;
}

.dashboard-header {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  color: white;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dashboard-header h1 {
  font-size: 24px;
  font-weight: 700;
}

.dashboard-header .btn {
  width: auto;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.dashboard-header .btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.dashboard-content {
  padding: 40px;
}

.welcome-card {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.welcome-card h2 {
  color: #1a1a2e;
  margin-bottom: 16px;
  font-size: 28px;
}

.welcome-card > p {
  color: #6b7280;
  margin-bottom: 8px;
}

.user-info {
  margin-top: 24px;
  padding: 24px;
  background: #f9fafb;
  border-radius: 12px;
}

.user-info p {
  margin-bottom: 12px;
  color: #6b7280;
}

.user-info p:last-child {
  margin-bottom: 0;
}

.user-info strong {
  color: #1a1a2e;
}

/* Responsive */
@media (max-width: 968px) {
  .auth-layout {
    flex-direction: column;
  }

  .auth-left {
    min-height: 350px;
  }

  .auth-right {
    padding: 30px 20px;
  }

  .central-platform {
    bottom: 20%;
  }
}

@media (max-width: 480px) {
  .auth-left {
    display: none;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .otp-input {
    width: 45px;
    height: 50px;
    font-size: 20px;
  }

  .otp-input-group {
    gap: 8px;
  }
}

/* ============================================
   DASHBOARD LAYOUT STYLES
   ============================================ */

/* CSS Variables for theming */
:root {
  --bg-primary: #ffffff;
  --bg-secondary: #f8fafc;
  --bg-tertiary: #f1f5f9;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --border-color: #e2e8f0;
  --accent-primary: #8b5cf6;
  --accent-secondary: #7c3aed;
  --success: #10b981;
  --warning: #f59e0b;
  --danger: #ef4444;
  --info: #3b82f6;
  --sidebar-width: 260px;
  --sidebar-collapsed-width: 70px;
  --header-height: 70px;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 16px;
}

/* Dark theme */
[data-theme="dark"] {
  --bg-primary: #0f172a;
  --bg-secondary: #1e293b;
  --bg-tertiary: #334155;
  --text-primary: #f1f5f9;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;
  --border-color: #334155;
}

/* Dashboard Layout */
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  background: var(--bg-secondary);
}

.dashboard-layout.sidebar-collapsed .sidebar {
  width: var(--sidebar-collapsed-width);
}

.dashboard-layout.sidebar-collapsed .main-content {
  margin-left: var(--sidebar-collapsed-width);
}

.main-content {
  flex: 1 1;
  margin-left: var(--sidebar-width);
  transition: margin-left 0.3s ease;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto;
}

/* Test Mode Ribbon */
.test-mode-ribbon {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);
  color: #ffffff;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  z-index: 900;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
}

.test-mode-ribbon span:first-child {
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 12px;
  border-radius: 4px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.test-mode-ribbon .ribbon-info {
  font-weight: 400;
  opacity: 0.95;
}

/* Adjust layout when test mode ribbon is shown */
.dashboard-layout:has(.test-mode-ribbon) .sidebar {
  top: 40px;
  height: calc(100vh - 40px);
}

.dashboard-layout:has(.test-mode-ribbon) .main-content {
  padding-top: 40px;
}

.dashboard-layout:has(.test-mode-ribbon) .header {
  top: 40px;
}

/* Ensure drawers and modals appear above the test mode ribbon */
.dashboard-layout:has(.test-mode-ribbon) .drawer-overlay,
.dashboard-layout:has(.test-mode-ribbon) .drawer,
.dashboard-layout:has(.test-mode-ribbon) .modal-overlay {
  z-index: 1000;
}

/* Onboarding deep-link return banner (shown on Invoices/Developer when the
   merchant arrives from the setup wizard). */
.onboarding-return-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: #f7f5fd;
  border: 1px solid #e6e0fa;
  border-radius: var(--radius-md, 10px);
  color: var(--text-secondary, #64748b);
  font-size: 14px;
}

.onboarding-return-btn {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  color: #fff;
  border: none;
  border-radius: var(--radius-sm, 6px);
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.onboarding-return-btn:hover {
  background: linear-gradient(135deg, #7c3aed, #6d28d9);
}

/* Dashboard onboarding card (activation + go-live). */
.onboarding-card {
  background: var(--bg-primary, #fff);
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: var(--radius-lg, 16px);
  box-shadow: var(--shadow-sm, 0 1px 2px 0 rgba(0, 0, 0, 0.05));
  padding: 24px;
  margin-bottom: 24px;
}

.onboarding-card-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 96px;
}

.onboarding-card-loading-text {
  color: var(--text-muted, #94a3b8);
  font-size: 14px;
}

.onboarding-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
}

.onboarding-card-head h2 {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary, #1e293b);
}

.onboarding-card-head p {
  margin-top: 4px;
  font-size: 14px;
  color: var(--text-secondary, #64748b);
}

.onboarding-card-cta {
  width: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.activation-progress {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary, #64748b);
  margin-bottom: 12px;
}

/* Go-live checklist (success screen + dashboard). */
.golive-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.golive-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: var(--radius-md, 10px);
  background: var(--bg-primary, #fff);
}

.golive-marker {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid var(--border-color, #e2e8f0);
  color: #fff;
  flex-shrink: 0;
}

.golive-item.done .golive-marker {
  background: var(--success, #10b981);
  border-color: transparent;
}

.golive-label {
  flex: 1 1;
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary, #1e293b);
}

.golive-item.done .golive-label {
  color: var(--text-secondary, #64748b);
  text-decoration: line-through;
}

.golive-action {
  background: none;
  border: none;
  color: var(--accent-secondary, #7c3aed);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  font-family: var(--iv-sans);
}

.golive-action:hover {
  text-decoration: underline;
}

.wiz-success-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: #ecfdf5;
  color: var(--success, #10b981);
}

/* Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 16px;
}

.loading-spinner.large {
  width: 40px;
  height: 40px;
  border-width: 3px;
  border-color: var(--border-color);
  border-top-color: var(--accent-primary);
}

.loading-spinner.small {
  width: 16px;
  height: 16px;
  border-width: 2px;
}

/* ============================================
   SIDEBAR STYLES
   ============================================ */

.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: var(--sidebar-width);
  background: var(--bg-primary);
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
  z-index: 100;
}

.sidebar.collapsed {
  width: var(--sidebar-collapsed-width);
}

.sidebar.collapsed .logo-text,
.sidebar.collapsed .nav-item span,
.sidebar.collapsed .version-info {
  display: none;
}

.sidebar.collapsed .logo {
  justify-content: center;
}

.sidebar.collapsed .nav-item {
  justify-content: center;
  padding: 12px;
}

.sidebar-header {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border-color);
  height: 70px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}
.logo img {
  max-width: 170px;
  padding: 8px;
  background-color: #fff;
}
.logo-icon {
  width: 40px;
  height: 40px;
  /* background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary)); */
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 18px;
}
.logo-icon img {
  padding-right: 8px;
  max-width: 40px;
  margin-left: -14px;
  margin-top: 6px;
}
.logo img.mobile_xl {
  display: none;
}
.sidebar-collapsed .sidebar-header {
  padding-bottom: 9px;
}
.logo-text {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
}

.collapse-btn {
  width: 28px;
  height: 28px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.collapse-btn:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.sidebar-nav {
  flex: 1 1;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s;
}

.nav-item:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.nav-item.active {
  background: linear-gradient(
    135deg,
    rgba(139, 92, 246, 0.1),
    rgba(124, 58, 237, 0.1)
  );
  color: var(--accent-primary);
}

.nav-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  width: 3px;
  height: 24px;
  background: var(--accent-primary);
  border-radius: 0 3px 3px 0;
}

.sidebar-footer {
  padding: 16px 20px;
  border-top: 1px solid var(--border-color);
}
.sidebar-collapsed .sidebar-footer {
  display: none;
}
.version-info {
  font-size: 12px;
  color: var(--text-muted);
}

/* ============================================
   HEADER STYLES
   ============================================ */

.dashboard-header {
  height: var(--header-height);
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-color);
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Mode Toggle */
.mode-toggle {
  position: relative;
  display: flex;
  background: var(--bg-secondary);
  border-radius: 20px;
  padding: 4px;
}

.mode-btn {
  padding: 6px 16px;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 16px;
  position: relative;
  z-index: 1;
  transition: color 0.2s;
}

.mode-btn.active {
  color: white;
}

.mode-btn-purple {
  padding: 8px 16px;
  border: none;
  background: linear-gradient(
    135deg,
    var(--accent-primary),
    var(--accent-secondary)
  );
  color: white;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.mode-btn-purple:hover {
  background: linear-gradient(
    135deg,
    var(--accent-primary),
    var(--accent-secondary)
  );
}

.mode-slider {
  position: absolute;
  top: 4px;
  left: 4px;
  width: calc(50% - 4px);
  height: calc(100% - 8px);
  background: var(--accent-primary);
  border-radius: 16px;
  transition: transform 0.3s ease;
}

.mode-slider.live {
  transform: translateX(100%);
  background: var(--success);
}

/* Icon Buttons */
.icon-btn {
  width: 40px;
  height: 40px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-primary);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.icon-btn:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
  border-color: var(--text-muted);
}

.notification-btn {
  position: relative;
}

.notification-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 18px;
  height: 18px;
  background: var(--danger);
  color: white;
  font-size: 10px;
  font-weight: 600;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Profile Dropdown */
.profile-dropdown {
  position: relative;
}

.profile-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-primary);
  cursor: pointer;
  transition: all 0.2s;
  font-family: var(--iv-sans);
}

.profile-btn:hover {
  background: var(--bg-secondary);
  border-color: var(--text-muted);
}

.avatar {
  width: 32px;
  height: 32px;
  background: linear-gradient(
    135deg,
    var(--accent-primary),
    var(--accent-secondary)
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 14px;
}

.profile-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.profile-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}

.profile-email {
  font-size: 12px;
  color: var(--text-muted);
}

.profile-btn svg {
  color: var(--text-muted);
  transition: transform 0.2s;
}

.profile-btn svg.rotate {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 200px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  padding: 8px;
  z-index: 100;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: all 0.2s;
  font-family: var(--iv-sans);
}

.dropdown-item:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.dropdown-item.logout {
  color: var(--danger);
}

.dropdown-item.logout:hover {
  background: rgba(239, 68, 68, 0.1);
}

.dropdown-divider {
  height: 1px;
  background: var(--border-color);
  margin: 8px 0;
}

/* ============================================
   PAGE HEADER STYLES
   ============================================ */

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}

.page-header h1 {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.page-header p {
  font-size: 14px;
  color: var(--text-secondary);
}

/* ============================================
   BUTTON STYLES
   ============================================ */

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(
    135deg,
    var(--accent-primary),
    var(--accent-secondary)
  );
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  width: auto;
  font-family: var(--iv-sans);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  width: auto;
  font-family: var(--iv-sans);
}

.btn-secondary:hover {
  background: var(--bg-secondary);
  border-color: var(--text-muted);
}

/* ============================================
   CARD STYLES
   ============================================ */

.card {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  /* overflow: hidden; */
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
}

.card-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.view-all {
  font-size: 14px;
  color: var(--accent-primary);
  text-decoration: none;
  font-weight: 500;
}

.view-all:hover {
  text-decoration: underline;
}

.card-body {
  padding: 20px 24px;
}

/* ============================================
   HOME PAGE STYLES
   ============================================ */

.home-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.test-mode-banner {
  padding: 12px 16px;
  background: rgba(139, 92, 246, 0.1);
  border: 1px solid rgba(139, 92, 246, 0.2);
  border-radius: var(--radius-md);
}

.test-mode-banner span {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent-primary);
  text-transform: uppercase;
  margin-bottom: 4px;
}

.test-mode-banner p {
  font-size: 13px;
  color: var(--text-secondary);
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.stat-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.stat-content {
  flex: 1 1;
}

.stat-title {
  display: block;
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.stat-value {
  display: block;
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.stat-change {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 20px;
}

.stat-change.positive {
  background: rgba(16, 185, 129, 0.1);
  color: var(--success);
}

.stat-change.negative {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger);
}

/* Dashboard Grid */
.dashboard-grid {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 20px;
}

.dashboard-grid .recent-transactions {
  grid-row: span 2;
}

/* Recent Transactions */
.transaction-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border-color);
}

.transaction-item:last-child {
  border-bottom: none;
}

.transaction-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
}

.transaction-icon .incoming {
  color: var(--success);
}

.transaction-icon .outgoing {
  color: var(--danger);
}

.transaction-details {
  flex: 1 1;
}

.transaction-title {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.transaction-date {
  font-size: 12px;
  color: var(--text-muted);
}

.transaction-amount {
  font-size: 14px;
  font-weight: 600;
}

.transaction-amount.incoming {
  color: var(--success);
}

.transaction-amount.outgoing {
  color: var(--danger);
}

/* Quick Actions */
.quick-actions .card-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

/* Balance Overview */
.balance-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border-color);
}

.balance-item:last-child {
  border-bottom: none;
}

.balance-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: 700;
}

.balance-icon.btc {
  background: linear-gradient(145deg, #f7931a, #c77700);
}

.balance-icon.eth {
  background: linear-gradient(145deg, #627eea, #3c4fd1);
}

.balance-icon.usdt {
  background: linear-gradient(145deg, #26a17b, #1a7a5c);
}

.balance-details {
  flex: 1 1;
}

.crypto-name {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}

.crypto-balance {
  font-size: 12px;
  color: var(--text-muted);
}

.balance-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: var(--text-muted);
}

.empty-state svg {
  /* margin-bottom: 16px; */
  /* opacity: 0.5; */
}

.empty-state p {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.empty-state span {
  font-size: 14px;
}

/* ============================================
   STATS ROW
   ============================================ */

.stats-row {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.stat-item {
  flex: 1 1;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 16px 20px;
}

.stat-label {
  display: block;
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.stat-item .stat-value {
  font-size: 20px;
}

.stat-item .stat-value.positive {
  color: var(--success);
}

.stat-item .stat-value.negative {
  color: var(--danger);
}

/* ============================================
   DATA TABLE STYLES
   ============================================ */

.data-table-container {
  width: 100%;
}
.payment-links-page .card .data-table-container {
  overflow: scroll;
}
.table-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color);
  flex-wrap: wrap;
  gap: 12px;
}

.controls-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.controls-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-box .search {
  position: absolute;
  left: 12px;
  color: var(--text-muted);
}

.search-box input {
  padding: 10px 36px 10px 40px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 14px;
  width: 250px;
  transition: all 0.2s;
}

.search-box input:focus {
  outline: none;
  border-color: var(--accent-primary);
  background: var(--bg-primary);
}

.clear-search {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 4px;
}

.date-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-secondary);
  color: var(--text-primary);
  min-width: 250px;
}

.date-filter input {
  color: var(--text-primary) !important;
  -webkit-text-fill-color: var(--text-primary) !important;
}

.date-picker-input {
  border: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 14px;
  width: 200px;
  outline: none;
}

.filter-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.filter-btn:hover,
.filter-btn.active {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.filter-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 8px;
  height: 8px;
  background: var(--accent-primary);
  border-radius: 50%;
}

/* Inline Filter Styles */
.inline-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-secondary);
  color: var(--text-secondary);
}

.inline-filter svg {
  flex-shrink: 0;
  color: var(--text-secondary);
}

.inline-filter-select {
  border: none;
  background: transparent;
  font-size: 14px;
  color: var(--text-primary);
  cursor: pointer;
  outline: none;
  padding-right: 8px;
}

.inline-filter-select:focus {
  outline: none;
}

.clear-filters-btn {
  background: none;
  border: none;
  color: var(--accent-primary);
  font-size: 14px;
  cursor: pointer;
  padding: 8px 12px;
}

.clear-filters-btn:hover {
  text-decoration: underline;
}

.results-count {
  font-size: 14px;
  color: var(--text-muted);
}

.column-filters {
  display: flex;
  gap: 16px;
  padding: 16px 20px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
  flex-wrap: wrap;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-item label {
  font-size: 12px;
  color: var(--text-muted);
}

.filter-item select {
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 14px;
  min-width: 150px;
}

/* .table-wrapper {
  overflow-x: auto;
  overflow-y: visible;
} */

.data-table {
  width: 100%;
  border-collapse: collapse;
  overflow: scroll;
}
.data-table th {
  text-align: left;
  padding: 14px 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-muted);
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
  white-space: nowrap;
}

.data-table th.sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.data-table th.sortable:hover {
  color: var(--text-primary);
}

.data-table th.sorted {
  color: var(--accent-primary);
}

.th-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sort-icons {
  display: flex;
  flex-direction: column;
  gap: -2px;
}

.sort-icons svg {
  color: var(--text-muted);
  opacity: 0.3;
}

.sort-icons svg.active {
  color: var(--accent-primary);
  opacity: 1;
}

.data-table td {
  padding: 16px;
  font-size: 14px;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-color);
  vertical-align: middle;
}

.data-table tr:hover {
  background: var(--bg-secondary);
}

.data-table tr.clickable {
  cursor: pointer;
}

.data-table tr.empty-row:hover {
  background: transparent;
}

/* Status Badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.status-badge.active,
.status-badge.completed,
.status-badge.paid {
  background: rgba(16, 185, 129, 0.1);
  color: var(--success);
}

.status-badge.pending {
  background: rgba(245, 158, 11, 0.1);
  color: var(--warning);
}

.status-badge.inactive,
.status-badge.failed,
.status-badge.cancelled {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger);
}

.status-badge.overdue {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger);
}

.status-badge.draft {
  background: var(--bg-secondary);
  color: var(--text-muted);
}

/* Type Badge */
/* Scoped to the public invoice page. Unscoped, this also matched the
   dashboard's Recent-invoices rows, where width: 100% on a flex-shrink: 0
   column collapsed the name/ID column to zero and the status/amount/date
   group rendered on top of the overflowing name. */
.public-invoice-page .invoice-meta {
  width: 100%;
  text-align: right;
}
.invoice-meta span.status-badge.partially_paid {
  color: #fef4c6;
}
.type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.type-badge.incoming {
  background: rgba(16, 185, 129, 0.1);
  color: var(--success);
}

.type-badge.outgoing {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger);
}

/* Action Buttons */
.action-buttons {
  display: flex;
  align-items: center;
  gap: 4px;
}

.action-icon-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.action-icon-btn:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.action-icon-btn.danger:hover {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger);
}

/* Action Dropdown Menu */
.action-dropdown {
  position: relative;
}

.action-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 160px;
  z-index: 9999;
  padding: 0.25rem 0;
}

.action-dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: none;
  color: var(--text-primary);
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  transition: background 0.2s;
}

.action-dropdown-menu .dropdown-item:hover {
  background: var(--bg-secondary);
}

.action-dropdown-menu .dropdown-item.danger {
  color: var(--danger);
}

.action-dropdown-menu .dropdown-item.danger:hover {
  background: rgba(239, 68, 68, 0.1);
}

/* Pagination */
.table-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid var(--border-color);
}

.pagination-info {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  color: var(--text-secondary);
}

.page-size-select {
  padding: 6px 10px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 14px;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pagination-btn {
  width: 36px;
  height: 36px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-primary);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  font-size: 14px;
}

.pagination-btn:hover:not(:disabled) {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  background: var(--bg-primary);
}

.pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.page-numbers {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0 4px;
}

.page-number {
  min-width: 36px;
  height: 36px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-primary);
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-number:hover:not(.active) {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.page-number.active {
  background: var(--accent-primary);
  color: white;
  border-color: var(--accent-primary);
}

.page-ellipsis {
  padding: 0 8px;
  color: var(--text-muted);
  font-size: 14px;
}

/* ============================================
   BALANCE PAGE STYLES
   ============================================ */

.balance-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.refresh-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.total-balance-card {
  background: linear-gradient(
    135deg,
    var(--accent-primary),
    var(--accent-secondary)
  );
  border-radius: var(--radius-lg);
  padding: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.total-balance-info .label {
  display: block;
  font-size: 14px;
  opacity: 0.8;
  margin-bottom: 8px;
}

.total-balance-info .value {
  display: block;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 8px;
}

.total-balance-info .change {
  font-size: 14px;
  opacity: 0.9;
}

.total-balance-actions {
  display: flex;
  gap: 12px;
}

.total-balance-actions .btn-primary {
  background: white;
  color: var(--accent-primary);
}

.total-balance-actions .btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  color: white;
}

.balance-tabs {
  display: flex;
  gap: 8px;
  padding: 4px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  width: fit-content;
}

.balance-tabs .tab {
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: all 0.2s;
}

.balance-tabs .tab:hover {
  color: var(--text-primary);
}

.balance-tabs .tab.active {
  background: var(--accent-primary);
  color: white;
}

.crypto-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.crypto-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 20px;
}

.crypto-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.crypto-card .crypto-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 700;
}

.crypto-card .crypto-icon.btc {
  background: linear-gradient(145deg, #f7931a, #c77700);
}

.crypto-card .crypto-icon.eth {
  background: linear-gradient(145deg, #627eea, #3c4fd1);
}

.crypto-card .crypto-icon.usdt {
  background: linear-gradient(145deg, #26a17b, #1a7a5c);
}

.crypto-card .crypto-icon.usdc {
  background: linear-gradient(145deg, #2775ca, #1a5ba3);
}

.crypto-card .crypto-icon.sol {
  background: linear-gradient(145deg, #9945ff, #14f195);
}

.crypto-card .crypto-icon.bnb {
  background: linear-gradient(145deg, #f3ba2f, #c99a00);
}

.crypto-info {
  flex: 1 1;
}

.crypto-card .crypto-name {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.crypto-symbol {
  font-size: 13px;
  color: var(--text-muted);
}

.crypto-price {
  text-align: right;
}

.crypto-price .price {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}

.crypto-price .change {
  font-size: 12px;
}

.crypto-price .change.positive {
  color: var(--success);
}

.crypto-price .change.negative {
  color: var(--danger);
}

.crypto-balance {
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  padding: 16px;
  margin-bottom: 16px;
}

.balance-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.balance-row .label {
  font-size: 13px;
  color: var(--text-secondary);
}

.balance-row .value {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}

.balance-row .value.usd {
  font-size: 18px;
  font-weight: 700;
}

.crypto-address {
  margin-bottom: 16px;
}

.address-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.address-header span {
  font-size: 13px;
  color: var(--text-secondary);
}

.toggle-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 4px;
}

.address-content {
  display: flex;
  gap: 8px;
}

.address-input {
  flex: 1 1;
  padding: 10px 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-family: monospace;
  color: var(--text-primary);
}

.copy-btn,
.qr-btn {
  width: 36px;
  height: 36px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  color: var(--text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.copy-btn:hover,
.qr-btn:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.crypto-actions {
  display: flex;
  gap: 12px;
}

.crypto-actions .action-btn {
  flex: 1 1;
  justify-content: center;
  padding: 12px;
  font-weight: 500;
}

.crypto-actions .action-btn.deposit {
  background: var(--success);
  border-color: var(--success);
  color: white;
}

.crypto-actions .action-btn.withdraw {
  background: var(--bg-primary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.test-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(139, 92, 246, 0.1);
  border: 1px solid rgba(139, 92, 246, 0.2);
  border-radius: var(--radius-md);
  color: var(--accent-primary);
  font-size: 14px;
}

/* ============================================
   PAYMENT LINKS PAGE STYLES
   ============================================ */

.payment-links-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.link-name-cell {
  display: flex;
  flex-direction: column;
}

.link-name {
  font-weight: 500;
  color: var(--text-primary);
}

.link-id {
  font-size: 12px;
  color: var(--text-muted);
  font-family: monospace;
}

/* ============================================
   TRANSACTIONS PAGE STYLES
   ============================================ */

.transactions-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.transaction-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tx-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
}

.tx-icon.incoming {
  color: var(--success);
}

.tx-icon.outgoing {
  color: var(--danger);
}

.tx-info {
  display: flex;
  flex-direction: column;
}

.tx-id {
  font-size: 13px;
  font-family: monospace;
  color: var(--text-primary);
}

.tx-description {
  font-size: 12px;
  color: var(--text-muted);
}

.amount-cell {
  display: flex;
  flex-direction: column;
}

.amount-cell .amount {
  font-weight: 600;
}

.amount-cell .amount.incoming {
  color: var(--success);
}

.amount-cell .amount.outgoing {
  color: var(--danger);
}

.amount-cell .crypto-amount {
  font-size: 12px;
  color: var(--text-muted);
}

/* Transaction Detail Modal */
.transaction-detail-modal .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid var(--border-color);
}

.transaction-detail-modal .detail-row:last-child {
  border-bottom: none;
}

.transaction-detail-modal .label {
  font-size: 13px;
  color: var(--text-secondary);
}

.transaction-detail-modal .value {
  font-size: 14px;
  color: var(--text-primary);
  text-align: right;
  word-break: break-all;
  max-width: 60%;
}

.transaction-detail-modal .value.hash {
  font-family: monospace;
  font-size: 12px;
}

/* Transactions Tabs */
.transactions-tabs {
  display: flex;
  gap: 0;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 0;
}

.transactions-tabs .tab-btn {
  padding: 12px 20px;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.transactions-tabs .tab-btn:hover {
  color: var(--text-primary);
}

.transactions-tabs .tab-btn.active {
  color: var(--text-primary);
  border-bottom-color: var(--accent-primary);
}

/* Status Filter Tabs */
.status-tabs {
  display: flex;
  gap: 8px;
  padding: 16px 0;
  flex-wrap: wrap;
}

.status-tab {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 16px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;
  min-width: 100px;
  transition: all 0.2s ease;
}

.status-tab:hover {
  border-color: var(--accent-primary);
}

.status-tab.active {
  border-color: var(--accent-primary);
  background: rgba(99, 102, 241, 0.05);
}

.status-tab .tab-label {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.status-tab .tab-count {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

/* Table Toolbar */
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.search-box {
  position: relative;
  flex: 1 1;
  max-width: 300px;
}

.search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
}

.search-box input {
  width: 100%;
  padding: 10px 12px 10px 40px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 14px;
  font-family: var(--iv-sans);
}

.search-box input::placeholder {
  color: var(--text-muted);
}

.toolbar-actions {
  display: flex;
  gap: 8px;
}

.btn-toolbar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: var(--iv-sans);
}

.btn-toolbar:hover {
  border-color: var(--text-muted);
  color: var(--text-primary);
}

.dropdown-container {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 180px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 0.25rem 0;
}

.dropdown-header {
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  border-bottom: 1px solid var(--border-color);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 10px 14px;
  background: none;
  border: none;
  text-align: left;
  font-size: 14px;
  color: var(--text-primary);
  cursor: pointer;
  transition: background 0.2s ease;
}

.dropdown-item:hover {
  background: var(--bg-secondary);
}

.dropdown-item.active {
  background: rgba(99, 102, 241, 0.1);
  color: var(--accent-primary);
}

.dropdown-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  font-size: 14px;
  color: var(--text-primary);
  cursor: pointer;
}

.dropdown-checkbox:hover {
  background: var(--bg-secondary);
}

.dropdown-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--accent-primary);
}

/* Transactions Table */
.transactions-table-container {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
}

.transactions-table {
  width: 100%;
  border-collapse: collapse;
}

.transactions-table thead {
  background: var(--bg-secondary);
}

.transactions-table th {
  padding: 12px 16px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border-color);
}

.transactions-table th.sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.transactions-table th.sortable:hover {
  color: var(--text-primary);
}

.transactions-table th svg {
  margin-left: 4px;
  vertical-align: middle;
  transition: transform 0.2s ease;
}

.transactions-table th svg.rotate-180 {
  transform: rotate(180deg);
}

.transactions-table tbody tr {
  cursor: pointer;
  transition: background 0.2s ease;
}

.transactions-table tbody tr:hover {
  background: var(--bg-secondary);
}

.transactions-table td {
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-color);
}

.transactions-table tbody tr:last-child td {
  border-bottom: none;
}

.amount-cell .amount-primary {
  font-weight: 500;
  color: var(--text-primary);
}

.amount-cell .amount-secondary {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
}

.customer-info .customer-name {
  font-weight: 500;
  color: var(--text-primary);
}

.customer-info .customer-email {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
}

.description-text {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.date-cell {
  white-space: nowrap;
}

/* Merchant column for Super Admin */
.merchant-cell {
  min-width: 150px;
}

.merchant-cell .merchant-info {
  display: flex;
  flex-direction: column;
}

.merchant-cell .merchant-name {
  font-weight: 500;
  color: var(--text-primary);
}

.merchant-cell .merchant-email {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.status-badge.status-created {
  background: rgba(99, 102, 241, 0.1);
  color: #6366f1;
}

.status-badge.status-pending {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.status-badge.status-processing {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.status-badge.status-succeeded {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}

.status-badge.status-failed {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.status-badge.status-refunded {
  background: rgba(168, 85, 247, 0.1);
  color: #a855f7;
}

.status-badge.status-disputed {
  background: rgba(249, 115, 22, 0.1);
  color: #f97316;
}

.status-badge.status-uncaptured {
  background: rgba(107, 114, 128, 0.1);
  color: #6b7280;
}

.status-badge.status-not-supported {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

/* Pagination */
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.pagination-info {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: var(--text-secondary);
}

.page-size-select {
  padding: 6px 10px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 13px;
  cursor: pointer;
  font-family: var(--iv-sans);
}

/* Note: Pagination styles are defined in the Data Table section above */

/* Empty State */
.empty-state {
  padding: 60px 20px;
  text-align: center;
}

.empty-state p {
  font-size: 16px;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.empty-state span {
  font-size: 14px;
  color: var(--text-muted);
}

/* Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.loading-container p {
  margin-top: 16px;
  color: var(--text-muted);
}

/* ============================================
   PAYMENT LINK DETAIL PAGE STYLES
   ============================================ */

.payment-link-detail-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.back-btn:hover {
  color: var(--accent-primary);
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.detail-header-left {
  flex: 1 1;
}

.detail-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-muted);
  letter-spacing: 0.5px;
}

.detail-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 8px 0 4px;
}

.detail-title .detail-amount {
  font-weight: 400;
  color: var(--text-secondary);
}

.detail-subtitle {
  font-size: 14px;
  color: var(--text-muted);
}

.detail-header-right {
  display: flex;
  align-items: center;
}

.status-badge-large {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

.status-badge-large.active {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}

.status-badge-large.inactive {
  background: rgba(107, 114, 128, 0.1);
  color: #6b7280;
}

/* URL Copy Box */
.url-copy-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

.url-copy-box input {
  flex: 1 1;
  padding: 10px 14px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-family: monospace;
  font-size: 13px;
  color: var(--text-primary);
}

.url-copy-box input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-icon:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

/* Detail Content Layout */
.detail-content {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 24px;
}

.detail-content.full-width {
  grid-template-columns: 1fr;
}

@media (max-width: 1024px) {
  .detail-content {
    grid-template-columns: 1fr;
  }
  .invoices-table-card {
    overflow: scroll;
  }
  .table-wrapper {
    overflow: scroll;
  }
}

.detail-main {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Detail Section */
.detail-section {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  /* margin-bottom: 16px; */
}

.detail-grid {
  display: flex;
  flex-direction: column;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid var(--border-color);
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-key {
  font-size: 14px;
  color: var(--text-secondary);
}

.detail-value {
  font-size: 14px;
  color: var(--text-primary);
  text-align: right;
}

/* Status Badge */
.status-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.active {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}

.status-badge.inactive {
  background: rgba(107, 114, 128, 0.1);
  color: #6b7280;
}

/* Empty Payments */
.empty-payments {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.empty-payments .empty-icon {
  color: var(--text-muted);
  margin-bottom: 12px;
}

.empty-payments p {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.empty-payments span {
  font-size: 13px;
  color: var(--text-muted);
}

/* Events List */
.events-list {
  display: flex;
  flex-direction: column;
}

.event-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid var(--border-color);
}

.event-item:last-child {
  border-bottom: none;
}

.event-type {
  font-size: 14px;
  color: var(--text-primary);
}

.event-date {
  font-size: 13px;
  color: var(--text-muted);
}

/* Detail Sidebar */
.detail-sidebar {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.preview-section {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 20px;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.preview-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.preview-device-toggle {
  display: flex;
  gap: 4px;
}

.device-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
}

.device-btn:hover {
  border-color: var(--text-secondary);
  color: var(--text-secondary);
}

.device-btn.active {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: white;
}

/* Browser Preview */
.browser-preview {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
}

.browser-preview.mobile {
  max-width: 280px;
  margin: 0 auto 16px;
}

.browser-chrome {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
}

.browser-dots {
  display: flex;
  gap: 6px;
}

.browser-dots .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.browser-dots .dot.red {
  background: #ef4444;
}

.browser-dots .dot.yellow {
  background: #f59e0b;
}

.browser-dots .dot.green {
  background: #22c55e;
}

.browser-url {
  flex: 1 1;
  padding: 4px 10px;
  background: var(--bg-primary);
  border-radius: 4px;
  font-size: 11px;
  color: var(--text-muted);
  text-align: center;
}

.browser-content {
  padding: 20px;
  background: #f8f9fa;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Preview Card */
.preview-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 320px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.preview-logo {
  width: 40px;
  height: 40px;
  background: var(--accent-primary);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 18px;
  margin: 0 auto 12px;
}

.preview-mode-badge {
  display: inline-block;
  padding: 4px 8px;
  background: rgba(249, 115, 22, 0.1);
  color: #f97316;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 12px;
}

.preview-name {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 4px;
}

.preview-amount {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 16px;
}

.preview-details {
  margin-bottom: 16px;
}

.preview-detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.preview-detail-row:last-child {
  border-bottom: none;
}

.preview-detail-row span:first-child {
  color: #6b7280;
}

.preview-detail-row span:last-child {
  color: #111827;
  font-weight: 500;
}

.preview-pay-btn {
  width: 100%;
  padding: 12px;
  background: var(--accent-primary);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 12px;
}

.preview-powered {
  font-size: 11px;
  color: #9ca3af;
}

/* Preview Actions */
.preview-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.btn-full {
  width: 100%;
  justify-content: center;
}

.btn-danger-text {
  background: none;
  border: none;
  color: #ef4444;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.btn-danger-text:hover {
  color: #dc2626;
}

/* ============================================
   PAYMENT LINK DETAIL - TWO COLUMN LAYOUT
   ============================================ */

/* URL Copy Section */
.url-copy-section {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

.url-copy-section .url-input {
  flex: 1 1;
  padding: 10px 14px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-family: monospace;
  font-size: 13px;
  color: var(--text-primary);
}

.url-copy-section .url-input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

/* Two Column Layout */
.detail-content-two-column {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 24px;
}

@media (max-width: 1024px) {
  .detail-content-two-column {
    grid-template-columns: 1fr;
  }
}

.detail-left-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-right-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Amount Badge in Title */
.amount-badge {
  font-weight: 400;
  color: var(--text-secondary);
}

/* Empty Payments Section */
.empty-payments-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.empty-payments-section .empty-icon {
  color: var(--text-muted);
  margin-bottom: 12px;
}

.empty-payments-section .empty-title {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.empty-payments-section .empty-subtitle {
  font-size: 13px;
  color: var(--text-muted);
  margin-bottom: 16px;
}

/* Event Item */
.event-name {
  font-size: 14px;
  color: var(--text-primary);
}

/* Preview Section Enhancements */
.preview-content {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.preview-test-badge {
  display: inline-block;
  padding: 4px 8px;
  background: rgba(249, 115, 22, 0.1);
  color: #f97316;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
}

.preview-card-body {
  text-align: center;
}

.preview-button {
  width: 100%;
  padding: 12px;
  background: var(--accent-primary);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
}

.preview-device-icons {
  display: flex;
  gap: 4px;
}

.device-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
}

.device-icon:hover {
  border-color: var(--text-secondary);
  color: var(--text-secondary);
}

.device-icon.active {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: white;
}

/* Action Buttons Column */
.action-buttons-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.full-width {
  width: 100%;
  justify-content: center;
}

.btn-text {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: var(--radius-md);
  transition: all 0.2s ease;
}

.btn-text.danger {
  color: #ef4444;
}

.btn-text.danger:hover {
  background: rgba(239, 68, 68, 0.1);
}

.btn-text.success {
  color: #22c55e;
}

.btn-text.success:hover {
  background: rgba(34, 197, 94, 0.1);
}

/* ============================================
   INVOICES PAGE STYLES
   ============================================ */

.invoices-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.invoice-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.invoice-icon {
  color: var(--text-muted);
}

.invoice-info {
  display: flex;
  flex-direction: column;
}

.invoice-id {
  font-weight: 500;
  color: var(--text-primary);
}

.invoice-customer {
  font-size: 12px;
  color: var(--text-muted);
}

.email {
  font-size: 13px;
  color: var(--text-secondary);
}

/* Invoice Preview */
.invoice-preview {
  padding: 24px;
}

.invoice-header-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
}

.company-info h3 {
  font-size: 24px;
  color: var(--accent-primary);
  margin-bottom: 4px;
}

.company-info p {
  color: var(--text-muted);
  font-size: 14px;
}

.invoice-meta p {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

/* .bill-to {
  margin-bottom: 32px;
} */

.bill-to h4 {
  font-size: 12px;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 8px;
}

.bill-to p {
  font-size: 14px;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.invoice-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 24px;
}

.invoice-table th {
  text-align: left;
  padding: 12px;
  background: var(--bg-secondary);
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-muted);
  border: 1px solid var(--border-color);
}

.invoice-table td {
  padding: 12px;
  font-size: 14px;
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.invoice-table tfoot td {
  background: var(--bg-secondary);
}

/* ============================================
   DEVELOPER PAGE STYLES
   ============================================ */

.developer-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.developer-tabs {
  display: flex;
  gap: 8px;
  padding: 0px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  width: fit-content;
}

.developer-tabs .tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: all 0.2s;
  border-bottom: none !important;
  font-family: var(--iv-sans);
}

.developer-tabs .tab:hover {
  color: var(--text-primary);
}

.developer-tabs .tab.active {
  background: var(--accent-primary);
  color: white !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.25),
    0 8px 20px rgba(109, 93, 246, 0.35);
}

.token-card-body .token-height {
  min-height: 32px;
}

.mode-indicator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.mode-indicator.test {
  background: rgba(139, 92, 246, 0.1);
  color: var(--accent-primary);
}

.mode-indicator.live {
  background: rgba(16, 185, 129, 0.1);
  color: var(--success);
}

.key-item {
  padding: 20px 0;
  border-bottom: 1px solid var(--border-color);
}

.key-item:last-of-type {
  border-bottom: none;
}

.key-info {
  margin-bottom: 12px;
}

.key-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.key-description {
  font-size: 13px;
  color: var(--text-muted);
}

.key-value {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
}

.key-value code {
  flex: 1 1;
  font-family: monospace;
  font-size: 13px;
  color: var(--text-primary);
  word-break: break-all;
}

.key-actions {
  margin-top: 20px;
}

.warning-box {
  display: flex;
  gap: 16px;
  padding: 16px;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: var(--radius-md);
  margin-top: 20px;
}

.warning-box svg {
  color: #ffffff;;
  flex-shrink: 0;
}

.warning-box strong {
  display: block;
  font-size: 14px;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.warning-box p {
  font-size: 13px;
  color: var(--text-secondary);
}

/* Pending Wallet Request Banner */
.pending-request-banner {
  display: flex;
  gap: 16px;
  padding: 20px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: var(--radius-md);
  margin-bottom: 20px;
}

.pending-request-icon {
  flex-shrink: 0;
  color: var(--primary);
}

.pending-request-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 8px 0;
}

.pending-request-content > p {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0 0 16px 0;
}

.pending-request-details {
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
  padding: 12px 16px;
  margin-bottom: 16px;
}

.pending-request-details .detail-row {
  display: flex;
  gap: 12px;
  padding: 6px 0;
}

.pending-request-details .detail-row:not(:last-child) {
  border-bottom: 1px solid var(--border-color);
}

.pending-request-details .detail-label {
  font-size: 13px;
  color: var(--text-muted);
  min-width: 100px;
}

.pending-request-details .detail-value {
  font-size: 13px;
  color: var(--text-primary);
  word-break: break-all;
}

.pending-request-details .detail-value.mono {
  font-family: "SF Mono", "Monaco", "Menlo", monospace;
  font-size: 12px;
}

.btn-cancel-request {
  padding: 8px 16px;
  background: transparent;
  border: 1px solid var(--error);
  color: var(--error);
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel-request:hover {
  background: var(--error);
  color: white;
}

.btn-cancel-request:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Info Box (for wallet change info) */
.settings-section .info-box {
  display: flex;
  gap: 16px;
  padding: 16px;
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: var(--radius-md);
  margin-top: 20px;
}

.settings-section .info-box svg {
  color: var(--primary);
  flex-shrink: 0;
}

.settings-section .info-box strong {
  display: block;
  font-size: 14px;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.settings-section .info-box p {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

/* Webhooks */
.webhooks-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.webhook-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
}

.webhook-info {
  flex: 1 1;
}

.webhook-url {
  display: block;
  font-size: 14px;
  font-family: monospace;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.webhook-events {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.event-tag {
  padding: 4px 8px;
  background: var(--bg-primary);
  border-radius: 4px;
  font-size: 11px;
  font-family: monospace;
  color: var(--text-secondary);
}

.webhook-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.webhook-date {
  font-size: 12px;
  color: var(--text-muted);
}

.webhook-actions {
  display: flex;
  gap: 4px;
}

.events-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 12px;
}

.event-item {
  padding: 12px;
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
}

.event-item code {
  display: block;
  font-size: 13px;
  color: var(--accent-primary);
  margin-bottom: 4px;
}

.event-item span {
  font-size: 12px;
  color: var(--text-muted);
}

/* Quickstart */
.steps {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.step {
  display: flex;
  gap: 20px;
}

.step-number {
  width: 32px;
  height: 32px;
  background: var(--accent-primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  flex-shrink: 0;
}

.step-content {
  flex: 1 1;
}

.step-content h4 {
  font-size: 16px;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.step-content p {
  font-size: 14px;
  color: var(--text-secondary);
}

.code-block {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  font-family: monospace;
}

.code-block code {
  flex: 1 1;
  font-size: 13px;
  color: var(--text-primary);
}

.code-block.large {
  display: block;
  position: relative;
}

.code-block.large pre {
  white-space: pre-wrap;
  font-size: 13px;
  color: var(--text-primary);
  line-height: 1.6;
}

.code-block.large .icon-btn {
  position: absolute;
  top: 8px;
  right: 8px;
}

.language-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
}

.language-tabs button {
  padding: 6px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  color: var(--text-secondary);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.language-tabs button:hover {
  border-color: var(--text-muted);
}

.language-tabs button.active {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: white;
}

.resources-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 24px;
}

.resource-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  text-decoration: none;
  transition: all 0.2s;
}

.resource-card:hover {
  border-color: var(--accent-primary);
  box-shadow: var(--shadow-md);
}

.resource-card svg {
  color: var(--accent-primary);
  margin-bottom: 12px;
}

.resource-card h4 {
  font-size: 16px;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.resource-card p {
  font-size: 13px;
  color: var(--text-muted);
}

/* ============================================
   SETTINGS PAGE STYLES
   ============================================ */

.settings-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.settings-container {
  display: flex;
  gap: 24px;
}

.settings-sidebar {
  width: 240px;
  flex-shrink: 0;
}

.settings-tab {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: var(--radius-md);
  transition: all 0.2s;
  text-align: left;
}

.settings-tab:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.settings-tab.active {
  background: rgba(139, 92, 246, 0.1);
  color: var(--accent-primary);
}

.settings-content {
  flex: 1 1;
  min-width: 0;
}

.settings-section {
  margin-bottom: 24px;
}

.section-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}

.section-header svg {
  color: var(--accent-primary);
  flex-shrink: 0;
}

.section-header h2 {
  font-size: 20px;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.section-header p {
  font-size: 14px;
  color: var(--text-secondary);
}

.form-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 24px;
}

.form-card .form-group {
  margin-bottom: 20px;
}

.form-card .form-group:last-child {
  margin-bottom: 0;
}

.form-card .form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.form-card .form-group input,
.form-card .form-group select,
.form-card .form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 14px;
  transition: all 0.2s;
}

.form-card .form-group input:focus,
.form-card .form-group select:focus,
.form-card .form-group textarea:focus {
  outline: none;
  border-color: var(--accent-primary);
  background: var(--bg-primary);
}

.form-card .form-row {
  display: flex;
  gap: 16px;
}

.form-card .form-row .form-group {
  flex: 1 1;
}

.form-card h3 {
  font-size: 16px;
  color: var(--text-primary);
  margin-bottom: 16px;
}

.logo-upload {
  display: flex;
  align-items: center;
  gap: 16px;
}

.logo-preview {
  width: 80px;
  height: 80px;
  background: linear-gradient(
    135deg,
    var(--accent-primary),
    var(--accent-secondary)
  );
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 28px;
  font-weight: 700;
}

.hint {
  font-size: 12px;
  color: var(--text-muted);
  display: block;
  margin-top: 4px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--text-primary);
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: var(--accent-primary);
}

/* Toggle Switch */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bg-tertiary);
  transition: 0.3s;
  border-radius: 24px;
}

.toggle-switch .slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.toggle-switch input:checked + .slider {
  background-color: var(--accent-primary);
}

.toggle-switch input:checked + .slider:before {
  transform: translateX(20px);
}

.security-item,
.notification-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
}

.security-info,
.notification-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.security-info svg,
.notification-info svg {
  color: var(--text-muted);
}

.security-label,
.notification-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.security-description,
.notification-description {
  font-size: 13px;
  color: var(--text-muted);
}

.settings-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 24px;
  border-top: 1px solid var(--border-color);
}

.change-password-btn {
  width: auto !important;
}

/* Password Input Wrapper */
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  padding-right: 40px;
  width: 100%;
}

.password-toggle {
  position: absolute;
  right: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  transition: color 0.2s;
}

.password-toggle:hover {
  color: var(--text-primary);
  background: transparent;
}

/* Message Banner */
.message-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: var(--radius-md);
  margin-bottom: 16px;
}

.message-banner.success {
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #10b981;
}

.message-banner.error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #ef4444;
}

.message-banner.info {
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: #3b82f6;
}

.message-banner span {
  flex: 1 1;
  font-size: 14px;
}

.message-banner .close-btn {
  width: 24px;
  height: 24px;
  font-size: 18px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.message-banner .close-btn:hover {
  opacity: 1;
  background: transparent;
}

/* Error Text */
.error-text {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
}

/* Input Error State */
.input-error {
  border-color: #ef4444 !important;
}

.input-error:focus {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);
}

/* Input Disabled State */
.input-disabled {
  background-color: var(--bg-tertiary) !important;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
}

.loading-container p {
  color: var(--text-secondary);
  font-size: 14px;
}

/* ============================================
   MODAL STYLES
   ============================================ */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal {
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal.large {
  max-width: 700px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
}
.modal-header.title-cancel {
    justify-content: left;
}
.modal-header h2 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: var(--text-muted);
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
}

.close-btn:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
}

.modal-body .form-group {
  margin-bottom: 20px;
}

.modal-body .form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.modal-body .form-group input,
.modal-body .form-group select,
.modal-body .form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 14px;
  font-family: var(--iv-sans);
}

.input-with-addon {
  display: flex;
  align-items: center;
}

.input-with-addon .addon {
  padding: 12px 16px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-right: none;
  border-radius: var(--radius-md) 0 0 var(--radius-md);
  color: var(--text-muted);
}

.input-with-addon input {
  flex: 1 1;
  border-radius: 0;
}

.input-with-addon select {
  width: 100px;
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  border-left: none;
}

.input-with-addon .addon-right {
  padding: 12px 16px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-left: none;
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  color: var(--text-muted);
  font-weight: 500;
  min-width: 60px;
  text-align: center;
}

.input-with-addon input:only-child,
.input-with-addon input:first-child:not(:last-child) {
  border-radius: var(--radius-md) 0 0 var(--radius-md);
}

.crypto-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid var(--border-color);
}

/* Confirmation Modal */
.confirm-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  padding: 32px;
  max-width: 400px;
  width: 90%;
  z-index: 1001;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.confirm-modal-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.confirm-modal-icon.danger {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.confirm-modal-icon.warning {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.confirm-modal h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.confirm-modal p {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 24px;
  line-height: 1.5;
}

.confirm-modal p strong {
  color: var(--text-primary);
}

.confirm-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.confirm-modal-actions button {
  flex: 1 1;
  padding: 12px 20px;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-danger {
  background: #ef4444;
  color: white;
  border: none;
}

.btn-danger:hover:not(:disabled) {
  background: #dc2626;
}

.btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Invoice Items */
.invoice-items {
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  overflow: hidden;
  margin-bottom: 12px;
}

.item-row {
  display: grid;
  grid-template-columns: 1fr 80px 100px 100px 40px;
  gap: 8px;
  padding: 12px;
  align-items: center;
}

.item-row.header {
  background: var(--bg-secondary);
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-muted);
}

.item-row input {
  padding: 8px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 14px;
}

.item-total {
  font-size: 14px;
  color: var(--text-primary);
  text-align: right;
}

.remove-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: var(--text-muted);
  font-size: 18px;
  cursor: pointer;
  border-radius: var(--radius-sm);
}

.remove-btn:hover {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger);
}

.add-item-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: none;
  border: none;
  color: var(--accent-primary);
  font-size: 14px;
  cursor: pointer;
  font-family: var(--iv-sans);
}

.add-item-btn:hover {
  text-decoration: underline;
}

.invoice-summary {
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  padding: 16px;
  margin-top: 20px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
  color: var(--text-secondary);
}

.summary-row.total {
  border-top: 1px solid var(--border-color);
  padding-top: 16px;
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

/* ============================================
   RESPONSIVE STYLES
   ============================================ */

@media (max-width: 1280px) {
  .dashboard-layout {
    display: unset;
  }
  .transactions-table-container {
    overflow: scroll;
  }
}

@media (max-width: 1200px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .dashboard-grid {
    grid-template-columns: 1fr;
  }

  .resources-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .sidebar {
    width: var(--sidebar-collapsed-width);
  }

  .sidebar .logo-text,
  .sidebar .nav-item span,
  .sidebar .version-info {
    display: none;
  }

  .sidebar .logo {
    justify-content: center;
  }

  .sidebar .nav-item {
    justify-content: center;
    padding: 12px;
  }

  .main-content {
    margin-left: var(--sidebar-collapsed-width);
  }

  .settings-container {
    flex-direction: column;
  }

  .settings-sidebar {
    width: 100%;
    display: unset;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 8px;
  }

  .settings-tab {
    white-space: nowrap;
    flex-shrink: 0;
  }
  .logo img.desktop_lg {
    display: none;
  }
  .logo img.mobile_xl {
    display: block;
    padding-right: 8px;
    max-width: 40px;
  }
  .hide-logoBtn {
    display: none;
  }
  .sidebar-header {
    padding-bottom: 12px;
  }
  .sidebar-collapsed .collapse-btn  {
    margin-left: 0px;
  }
  .sidebar-header {
    justify-content: center;
  }
  .logo-icon img {
    margin-left: 0px;
    margin-top: 0px;
  }
  .token-card-body .token-height {
    min-height: 0px;
  }
  .sidebar-footer {
    display: none;
  }
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 16px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stats-row {
    flex-wrap: wrap;
  }

  .stat-item {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 8px);
  }

  .crypto-grid {
    grid-template-columns: 1fr;
  }

  .table-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .controls-left,
  .controls-right {
    flex-wrap: wrap;
  }

  .search-box input {
    width: 100%;
  }

  .header-right {
    gap: 8px;
  }

  .profile-info {
    display: none;
  }

  .resources-grid {
    grid-template-columns: 1fr;
  }

  .form-card .form-row {
    flex-direction: column;
  }
  .transactions-table-container {
    overflow: scroll;
  }
  .guide-nav-item span {
    display: block !important;
  }
}

@media (max-width: 576px) {
  /* .payment-amount{overflow-x:scroll;} */
  .sidebar {
    display: none;
  }

  .main-content {
    margin-left: 0;
  }

  .page-content {
    padding: 16px;
  }

  .total-balance-card {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .total-balance-actions {
    width: 100%;
    flex-direction: column;
  }
  .invoice-meta span.status-badge.partially_paid {
    font-size: 12px;
  }
  .brand img {
    max-width: 140px !important;
  }
}

/* React DatePicker Overrides */
.react-datepicker-wrapper {
  width: auto;
  display: inline-flex;
  align-items: center;
}

.react-datepicker__input-container {
  display: flex;
  align-items: center;
}

.react-datepicker__input-container input {
  border: none;
  background: transparent;
  color: var(--text-primary) !important;
  font-size: 14px;
  width: 200px;
  outline: none;
}

.react-datepicker {
  font-family: inherit;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  background: var(--bg-primary);
}

.react-datepicker__header {
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
}

.react-datepicker__current-month,
.react-datepicker__day-name,
.react-datepicker__day {
  color: var(--text-primary);
}

.react-datepicker__day--selected,
.react-datepicker__day--in-range,
.react-datepicker__day--in-selecting-range {
  background: var(--accent-primary) !important;
  color: #fff !important;
}

.react-datepicker__day:hover {
  background: var(--bg-tertiary);
}

.react-datepicker__day--keyboard-selected {
  background: var(--accent-primary);
  color: #fff;
}

/* Date picker clear button - make it visible */
.react-datepicker__close-icon {
  position: relative;
  right: 0;
  padding: 0 !important;
  display: flex !important;
  align-items: center;
  visibility: visible !important;
  opacity: 1 !important;
}

.react-datepicker__close-icon::after {
  background-color: #ef4444 !important;
  color: #fff !important;
  content: "×" !important;
  height: 20px !important;
  width: 20px !important;
  padding: 2px !important;
  font-size: 20px !important;

  line-height: 18px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.react-datepicker__close-icon:hover::after {
  background-color: #dc2626 !important;
}

/* Ensure date picker input text is visible */
.date-filter .react-datepicker__input-container input {
  color: var(--text-primary) !important;
  background: transparent !important;
  font-family: var(--iv-sans);
}

.date-filter .react-datepicker__input-container input::placeholder {
  color: var(--text-muted);
}

/* Date filter container adjustments */
.date-filter .react-datepicker-wrapper {
  flex: 1 1;
}

/* ============================================
   Advanced Filter Toolbar Styles
   ============================================ */

/* Search clear button */
.search-clear {
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-clear:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.search-box {
  position: relative;
}

/* Filter dropdown improvements */
.filter-dropdown {
  min-width: 280px;
  max-height: 400px;
  overflow-y: auto;
  left: 0;
  right: auto;
}

.dropdown-section {
  padding: 8px 0;
}

.dropdown-divider {
  height: 1px;
  background: var(--border-color);
  margin: 4px 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-secondary);
  transition: all 0.2s;
}

.dropdown-item:hover {
  background: var(--bg-tertiary);
}

.dropdown-item.active {
  color: var(--accent-primary);
  background: rgba(124, 58, 237, 0.08);
}

.dropdown-count {
  margin-left: auto;
  font-size: 12px;
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  padding: 2px 8px;
  border-radius: 10px;
}

/* Advanced filter button with badge */
.btn-toolbar.has-filters {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  background: rgba(124, 58, 237, 0.08);
}

.filter-count-badge {
  background: var(--accent-primary);
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 4px;
}

/* Column dropdown improvements */
.column-dropdown {
  min-width: 220px;
}

.dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid var(--border-color);
}

.reset-columns-btn {
  background: none;
  border: none;
  color: var(--accent-primary);
  cursor: pointer;
  font-size: 12px;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
}

.reset-columns-btn:hover {
  background: rgba(124, 58, 237, 0.1);
}

.dropdown-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-checkbox:hover {
  background: var(--bg-tertiary);
}

.dropdown-checkbox input[type="checkbox"] {
  display: none;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid var(--border-color);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.dropdown-checkbox input[type="checkbox"]:checked + .checkbox-custom {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: white;
}

/* Always-on columns: checked, not clickable, visibly inert. */
.dropdown-checkbox.is-locked {
  cursor: not-allowed;
  color: var(--text-secondary);
}

.dropdown-checkbox.is-locked:hover {
  background: transparent;
}

.dropdown-checkbox.is-locked .checkbox-custom {
  opacity: 0.55;
}

/* Clear all filters button */
.btn-clear-filters {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: transparent;
  border: 1px solid var(--error-color);
  color: var(--text-secondary);
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-clear-filters:hover {
  background: rgba(239, 68, 68, 0.1);
}

/* Column toggle container for DataTable */
.column-toggle-container {
  position: relative;
}

.column-toggle-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.column-toggle-btn:hover,
.column-toggle-btn.active {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.column-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  box-shadow: var(--shadow-lg);
  z-index: 100;
  min-width: 220px;
}

.column-dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border-color);
}

.column-dropdown-list {
  max-height: 300px;
  overflow-y: auto;
}

.column-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 14px;
  color: var(--text-primary);
}

.column-checkbox:hover {
  background: var(--bg-tertiary);
}

.column-checkbox input[type="checkbox"] {
  display: none;
}

/* Clear filters button in DataTable */
.clear-filters-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: transparent;
  border: none;
  color: var(--accent-primary);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.clear-filters-btn:hover {
  text-decoration: underline;
}

/* ===========================================
   Payment Page Styles
   =========================================== */

.payment-page {
  min-height: 100vh;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.payment-container {
  width: 100%;
  max-width: 420px;
}

.payment-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.payment-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px 32px;
  gap: 12px;
}
.payment-space {
  padding: 1rem;
}
.payment-logo {
  width: 56px;
  height: 56px;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  color: white;
}

.payment-test-badge {
  background: #fef3c7;
  color: #d97706;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 12px;
  letter-spacing: 0.5px;
}

.payment-details {
  text-align: center;
  padding: 0 24px 24px;
}

.payment-name {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 8px;
}

.payment-amount {
  font-size: 48px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 8px;
}

.payment-currency {
  font-size: 16px;
  font-weight: 500;
  color: #6b7280;
}

.payment-description {
  font-size: 13px;
  color: #6b7280;
  margin: 12px 0 0;
  line-height: 1.5;
}

.payment-timer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: #fef3c7;
  color: #d97706;
  font-size: 14px;
  font-weight: 500;
}

.payment-info {
  padding: 16px 24px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
}

.payment-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.payment-info-row:not(:last-child) {
  border-bottom: 1px solid #e5e7eb;
}

.info-label {
  font-size: 14px;
  color: #6b7280;
}

.info-value {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.payment-address {
  padding: 16px 24px;
}

.payment-address label {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.address-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #f3f4f6;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.address-text {
  flex: 1 1;
  font-size: 12px;
  font-family: monospace;
  color: #374151;
  word-break: break-all;
  color:#fff;
}

.copy-btn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
}

.copy-btn:hover {
  background: #f3f4f6;
  color: #111827;
}

.payment-buttons {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.payment-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.wallet-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.wallet-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.qr-btn {
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
}

.qr-btn:hover {
  background: #f5f3ff;
}

.payment-footer {
  padding: 16px 24px;
  text-align: center;
  border-top: 1px solid #e5e7eb;
}

.payment-footer p {
  font-size: 12px;
  color: #9ca3af;
  margin: 0;
}

.payment-footer strong {
  color: #6b7280;
}
.pc-powered {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 0.82rem;
  color: #9ca3af;
}
.pc-powered img {
  height: 18px;
  width: auto;
  margin-top: 1px;
}
/* Payment Status States */
.payment-loading,
.payment-error,
.payment-success,
.payment-expired,
.payment-inactive {
  padding: 60px 24px;
  text-align: center;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.payment-loading .loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.payment-loading p,
.payment-error p,
.payment-success p,
.payment-expired p,
.payment-inactive p {
  color: #6b7280;
  margin: 8px 0 0;
}

.error-icon {
  color: #ef4444;
  margin-bottom: 16px;
}

.success-icon {
  color: #10b981;
  margin-bottom: 16px;
}

.expired-icon {
  color: #f59e0b;
  margin-bottom: 16px;
}

.inactive-icon {
  color: #6b7280;
  margin-bottom: 16px;
}

.payment-error h2,
.payment-success h2,
.payment-expired h2,
.payment-inactive h2 {
  font-size: 20px;
  color: #111827;
  margin: 0 0 8px;
}

.paid-date,
.expired-hint {
  font-size: 13px;
  color: #9ca3af;
  margin-top: 8px;
}

/* QR Modal */
.qr-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.qr-modal {
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 360px;
  width: 100%;
  text-align: center;
}

.qr-modal h3 {
  font-size: 20px;
  color: #111827;
  margin: 0 0 8px;
}

.qr-hint {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 24px;
}

.qr-code-container {
  background: white;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  display: inline-block;
  margin-bottom: 16px;
}

.qr-code-container img {
  display: block;
  width: 250px;
  height: 250px;
}

.qr-amount {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
}

.qr-amount strong {
  font-size: 24px;
  color: #111827;
}

.qr-amount span {
  font-size: 14px;
  color: #6b7280;
}

.qr-close-btn {
  width: 100%;
  padding: 14px 24px;
  background: #f3f4f6;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
}

.qr-close-btn:hover {
  background: #e5e7eb;
}

/* Status badge colors for paid, expired */
.status-badge.paid,
.status-badge-large.paid {
  background: #d1fae5;
  color: #059669;
}

.status-badge.expired,
.status-badge-large.expired {
  background: #fef3c7;
  color: #d97706;
}

.status-badge.cancelled,
.status-badge-large.cancelled {
  background: #fee2e2;
  color: #dc2626;
}

/* ============================================
   Drawer Styles
   ============================================ */

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
}

.drawer-overlay.open {
  opacity: 1;
  visibility: visible;
}

.drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 480px;
  max-width: 100%;
  height: 100vh;
  background: var(--bg-primary);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s ease;
}

.drawer.open {
  transform: translateX(0);
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.drawer-header h2 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.drawer-close-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: var(--text-secondary);
  transition: all 0.2s;
}

.drawer-close-btn:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.drawer-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
}

.drawer-body .form-group {
  margin-bottom: 20px;
}

.drawer-body .form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.drawer-body .form-group input[type="text"],
.drawer-body .form-group input[type="number"],
.drawer-body .form-group select,
.drawer-body .form-group textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 14px;
  color: var(--text-primary);
  background: var(--bg-primary);
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.drawer-body .form-group input:focus,
.drawer-body .form-group select:focus,
.drawer-body .form-group textarea:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}

.drawer-body .form-group input:disabled,
.drawer-body .form-group select:disabled {
  background: var(--bg-secondary);
  color: var(--text-muted);
  cursor: not-allowed;
}

.drawer-body .input-with-addon {
  display: flex;
  align-items: stretch;
}

.drawer-body .input-with-addon input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

.drawer-body .input-with-addon .addon-right {
  display: flex;
  align-items: center;
  padding: 0 14px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-left: none;
  border-radius: 0 8px 8px 0;
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
}

.drawer-body .checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  cursor: pointer;
  font-weight: 400;
}

.drawer-body .checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: var(--accent-primary);
  cursor: pointer;
}

.drawer-body .checkbox-label span {
  font-size: 14px;
  color: var(--text-secondary);
}

.drawer-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid var(--border-color);
  background: var(--bg-secondary);
  flex-shrink: 0;
}

.drawer-footer .btn-secondary {
  flex: 1 1;
  padding: 12px 20px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.drawer-footer .btn-secondary:hover {
  background: var(--bg-secondary);
}

.drawer-footer .btn-primary {
  flex: 1 1;
  padding: 12px 20px;
  background: var(--accent-primary);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
}

.drawer-footer .btn-primary:hover:not(:disabled) {
  background: var(--accent-secondary);
}

.drawer-footer .btn-primary:disabled {
  background: var(--bg-tertiary);
  color: var(--text-muted);
  cursor: not-allowed;
}

/* Mobile responsiveness for drawer */
@media (max-width: 520px) {
  .drawer {
    width: 100%;
  }
}

/* =========================================
   Payment Links - API Key & New UI Styles
   ========================================= */

/* API Key Cell */
.api-key-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.api-key-value {
  font-family: "Monaco", "Menlo", monospace;
  font-size: 12px;
  background: var(--bg-secondary);
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-icon-btn.small {
  padding: 4px;
  width: 24px;
  height: 24px;
}

/* Link URL Cell */
.link-url-cell {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Link ID Small */
.link-id-small {
  font-family: "Monaco", "Menlo", monospace;
  font-size: 11px;
  color: var(--text-secondary);
  background: var(--bg-secondary);
  padding: 2px 6px;
  border-radius: 4px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Text Muted */
.text-muted {
  color: var(--text-muted);
  font-size: 12px;
  font-style: italic;
}

/* Link Description */
.link-description {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Address Cell */
.address-cell {
  font-family: "Monaco", "Menlo", monospace;
  font-size: 12px;
  color: var(--text-secondary);
}

/* Info Cards Row */
.info-cards-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.info-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 16px;
}

.info-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--text-muted);
  margin-bottom: 8px;
  font-weight: 500;
}

.info-card-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-card-content code {
  flex: 1 1;
  font-family: "Monaco", "Menlo", monospace;
  font-size: 12px;
  background: var(--bg-secondary);
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  color: var(--text-primary);
  word-break: break-all;
  overflow-x: auto;
}

.btn-icon.small {
  padding: 6px;
  border: 1px solid var(--border-color);
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
  cursor: pointer;
  color: var(--text-secondary);
  transition: all 0.2s;
}

.btn-icon.small:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

/* Drawer Info Box */
.drawer-info {
  color: var(--text-secondary);
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.5;
}

.info-box {
  background: rgba(139, 92, 246, 0.1);
  border: 1px solid rgba(139, 92, 246, 0.2);
  border-radius: var(--radius-md);
  padding: 16px;
  margin-top: 20px;
}

.info-box h4 {
  color: var(--accent-primary);
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
}

.info-box ol {
  margin: 0;
  padding-left: 20px;
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.8;
}

.info-box code {
  font-family: "Monaco", "Menlo", monospace;
  font-size: 11px;
  background: rgba(139, 92, 246, 0.2);
  padding: 2px 6px;
  border-radius: 4px;
  color: var(--accent-primary);
}

/* Form Hint */
.form-hint {
  display: block;
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 4px;
}

/* Header Actions */
.header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* Merchant Filter Dropdown */
.merchant-filter {
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 14px;
  min-width: 180px;
  cursor: pointer;
  outline: none;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.merchant-filter:hover {
  border-color: var(--primary-color);
}

.merchant-filter:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

/* Large Drawer */
.drawer.drawer-large {
  width: 680px;
  max-width: 90vw;
}

/* Usage Guide Content */
.usage-guide-content {
  padding: 0 !important;
}

.guide-section {
  padding: 24px;
  border-bottom: 1px solid var(--border-color);
}

.guide-section:last-child {
  border-bottom: none;
}

.guide-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.guide-section-header svg {
  color: var(--accent-primary);
}

.guide-section-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

/* Quick Start Steps */
.guide-steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.guide-step {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.step-number {
  width: 28px;
  height: 28px;
  background: var(--accent-primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.step-content h4 {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px 0;
}

.step-content p {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.5;
}

/* Code Block */
.code-block {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
}

.code-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
}

.method {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.method.post {
  background: #22c55e20;
  color: #22c55e;
}

.method.get {
  background: #3b82f620;
  color: #3b82f6;
}

.endpoint {
  font-family: "Monaco", "Menlo", monospace;
  font-size: 13px;
  color: var(--text-primary);
  flex: 1 1;
}

.copy-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  color: var(--text-secondary);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.copy-btn:hover {
  background: var(--accent-primary);
  color: white;
  border-color: var(--accent-primary);
}

.code-description {
  padding: 12px 16px;
}

.code-description p {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

/* Parameters Section */
.params-section {
  margin-bottom: 20px;
}

.params-section h4 {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 12px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.param-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
  border-bottom: 1px solid var(--border-color);
}

.param-item:last-child {
  border-bottom: none;
}

.param-name {
  font-family: "Monaco", "Menlo", monospace;
  font-size: 12px;
  background: var(--bg-tertiary);
  padding: 4px 8px;
  border-radius: 4px;
  color: var(--accent-primary);
}

.param-required {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
  background: #ef444420;
  color: #ef4444;
}

.param-optional {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--bg-tertiary);
  color: var(--text-muted);
}

.param-desc {
  width: 100%;
  font-size: 13px;
  color: var(--text-secondary);
  margin: 4px 0 0 0;
}

/* Response Example */
.response-example {
  background: #1e1e2e;
  color: #cdd6f4;
  padding: 16px;
  border-radius: 8px;
  font-family: "Monaco", "Menlo", monospace;
  font-size: 12px;
  line-height: 1.6;
  overflow-x: auto;
  margin: 0;
}

/* Code Examples */
.code-example {
  margin-bottom: 20px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
}

.code-example:last-child {
  margin-bottom: 0;
}

.code-example-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
}

.lang-badge {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.lang-badge.nodejs {
  background: #22c55e20;
  color: #22c55e;
}

.lang-badge.php {
  background: #8b5cf620;
  color: #8b5cf6;
}

.lang-badge.python {
  background: #3b82f620;
  color: #3b82f6;
}

.code-content {
  background: #1e1e2e;
  color: #cdd6f4;
  padding: 16px;
  font-family: "Monaco", "Menlo", monospace;
  font-size: 11px;
  line-height: 1.6;
  overflow-x: auto;
  margin: 0;
  max-height: 400px;
}

/* Security Info */
.security-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.security-item {
  padding: 16px;
  background: var(--bg-tertiary);
  border-radius: 8px;
}

.security-item.warning {
  background: #fef3c720;
  border: 1px solid #fbbf2440;
}

.security-item h4 {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 8px 0;
}

.security-item p {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.5;
}

.security-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
  font-size: 13px;
}

.security-table th,
.security-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.security-table th {
  background: var(--bg-secondary);
  font-weight: 600;
  color: var(--text-primary);
}

.security-table td {
  color: var(--text-secondary);
}

.result {
  font-weight: 500;
}

.result.success {
  color: #22c55e;
}

.result.error {
  color: #ef4444;
}

/* Flow Diagram */
.flow-diagram {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 20px;
  background: var(--bg-tertiary);
  border-radius: 12px;
  overflow-x: auto;
}

.flow-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 80px;
}

.flow-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 24px;
  margin-bottom: 8px;
}

.flow-icon.customer {
  background: #3b82f620;
}

.flow-icon.server {
  background: #8b5cf620;
}

.flow-icon.api {
  background: #22c55e20;
}

.flow-icon.redirect {
  background: #f59e0b20;
}

.flow-icon.payment {
  background: #ec489920;
}

.flow-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.flow-desc {
  font-size: 10px;
  color: var(--text-muted);
  line-height: 1.3;
}

.flow-arrow {
  color: var(--text-muted);
  font-size: 20px;
  flex-shrink: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .drawer.drawer-large {
    width: 100%;
  }

  .flow-diagram {
    flex-wrap: wrap;
    justify-content: center;
  }

  .flow-arrow {
    display: none;
  }
}

/* ============================================
   Session Detail Drawer Styles
   ============================================ */

/* Session Status Banner */
.session-status-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
}

.session-status-banner.paid {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-color: #86efac;
}

.session-status-banner.pending {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border-color: #fcd34d;
}

.session-status-banner.expired,
.session-status-banner.failed {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #fca5a5;
}

.session-status-banner.processing {
  background: linear-gradient(135deg, #f0f9ff 0%, #dbeafe 100%);
  border-color: #93c5fd;
}

.session-amount-large {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
}

/* Drawer Sections */
.drawer-section {
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-color);
}

.drawer-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.drawer-section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Detail Grid */
.detail-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.detail-key {
  font-size: 13px;
  color: var(--text-muted);
  flex-shrink: 0;
  min-width: 120px;
}

.detail-value {
  font-size: 13px;
  color: var(--text-primary);
  text-align: right;
  word-break: break-word;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.detail-value.mono {
  font-family: "JetBrains Mono", "Fira Code", monospace;
  font-size: 12px;
}

/* Session Transactions List */
.session-transactions-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.session-transaction-item {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 14px 16px;
}

.tx-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.tx-amount {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.tx-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tx-detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.tx-label {
  color: var(--text-muted);
  min-width: 70px;
}

.tx-value {
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 4px;
}

.tx-value.mono {
  font-family: "JetBrains Mono", "Fira Code", monospace;
}

/* Empty Transactions */
.empty-transactions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: var(--bg-secondary);
  border-radius: 10px;
  border: 1px dashed var(--border-color);
  color: var(--text-muted);
}

.empty-transactions svg {
  margin-bottom: 8px;
  opacity: 0.5;
}

.empty-transactions p {
  font-size: 13px;
  margin: 0;
}

/* Metadata Block */
.metadata-block {
  background: #1e1e2e;
  border-radius: 8px;
  padding: 12px 16px;
  overflow-x: auto;
}

.metadata-block pre {
  margin: 0;
  color: #cdd6f4;
  font-family: "JetBrains Mono", "Fira Code", monospace;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Text color utilities */
.text-success {
  color: #10b981 !important;
}

.text-warning {
  color: #f59e0b !important;
}

.text-error {
  color: #ef4444 !important;
}

/* Small button icon */
.btn-icon.small {
  width: 24px;
  height: 24px;
  padding: 4px;
  border: none;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-icon.small:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}

/* Status Badge Large */
.status-badge-large {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  text-transform: capitalize;
}

.status-badge-large.paid {
  background: #dcfce7;
  color: #166534;
}

.status-badge-large.pending {
  background: #fef3c7;
  color: #92400e;
}

.status-badge-large.processing {
  background: #dbeafe;
  color: #1e40af;
}

.status-badge-large.expired,
.status-badge-large.failed {
  background: #fee2e2;
  color: #991b1b;
}

.status-badge-large.partially_paid {
  background: #fef3c7;
  color: #92400e;
}

/* Responsive for session drawer */
@media (max-width: 991px) {
  .support-icon {
    word-wrap: break-word;
  }
}

@media (max-width: 520px) {
  .session-status-banner {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .detail-row {
    flex-direction: column;
    gap: 4px;
  }

  .detail-key {
    min-width: unset;
  }

  .detail-value {
    text-align: left;
    justify-content: flex-start;
  }
  .dashboard-layout:has(.test-mode-ribbon) .sidebar {
    top: 0px;
    height: calc(100vh - 0px);
  }
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #cbd5e1; /* slate-300 */
  border-radius: 9999px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8; /* slate-400 */
}

body.modal-open {
  overflow: hidden;
  height: 100vh;
}

.support-icon {
  font-size: smaller;
}
.mode-btn:hover {
  background-color: #eef3ff;
  border-color: #4f6df5;
  color: #4f6df5;
}

.icon-btn-apidoc {
  width: 75px;
  height: 40px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-primary);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.icon-btn-apidoc:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
  border-color: var(--text-muted);
}

.need-help {
  font-size: 13px;
  color: var(--text-muted);
}

/* ---- Cloudflare Turnstile (auth forms) ---- */
.turnstile-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-bottom: 20px;
  margin-top:10px;
  min-height: 65px;
}

.turnstile-widget {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 300px;
}

.turnstile-widget iframe {
  max-width: 100%;
}
/* ─── Toast dismiss control (react-hot-toast) ─────────────────────────────
   The library ships no close control, so toasts could only be waited out.
   Rather than add a second X, AppToaster wraps the status icon on the left in
   a button — this rule strips the button chrome so the icon looks exactly as
   the library drew it, and only adds the hover/focus affordance that tells
   people it is now clickable. */
.toast-dismiss-icon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.toast-dismiss-icon:hover {
  opacity: 0.75;
}

.toast-dismiss-icon:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.9);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .toast-dismiss-icon {
    transition: none;
  }
}

/* ── DataTable: Quick Filters variant ─────────────────────────────────────
   The same control the Transactions page uses, lifted out of that page's
   \\3c style jsx> block so any DataTable can opt into it with filterVariant="quick".
   Class names are prefixed .dtqf- rather than reusing .qf-: the Transactions
   copy is emitted globally while that page is mounted, and two definitions of
   the same selector would fight depending on which route was open. */
.dt-quick-filter { position: relative; display: inline-flex; }

.dtqf-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid var(--line-strong, #dddfec);
  border-radius: var(--r-sm, 10px);
  background: var(--surface, #fff);
  color: var(--t-700, #3b4059);
  font: inherit;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}
.dtqf-trigger:hover {
  border-color: var(--brand-400, #a99cff);
  color: var(--brand-700, #5847d6);
}
/* An active filter has to be visible from the closed state, or a merchant
   wonders why the table is missing rows. */
.dtqf-trigger.is-filtered {
  border-color: var(--brand-600, #6d5df6);
  background: var(--brand-100, #ece9ff);
  color: var(--brand-700, #5847d6);
  font-weight: 600;
}
.dtqf-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--brand-600, #6d5df6);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.dtqf-panel {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 60;
  min-width: 300px;
  max-height: 40vh;
  overflow-y: auto;
  background: var(--surface, #fff);
  border: 1px solid var(--line, #eaebf3);
  border-radius: var(--r-md, 12px);
  box-shadow: 0 12px 32px rgba(14, 17, 36, 0.14);
}
.dtqf-top {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid var(--line, #eaebf3);
  background: var(--bg-inset, #eff0f8);
  z-index: 9;
}
.dtqf-top-title { font-size: 12.5px; font-weight: 700; color: var(--ink, #0e1124); }
.dtqf-reset {
  border: none;
  background: none;
  padding: 2px 4px;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent, #6d5df6);
  cursor: pointer;
}
.dtqf-reset:hover { text-decoration: underline; }

.dtqf-section { padding: 6px; }
.dtqf-header {
  padding: 6px 8px 4px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--t-500, #6c7189);
}
/* Subheading inside a section, for options that declare a \`group\`. */
.dtqf-group {
  padding: 8px 8px 3px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--t-400, #9aa0b6);
}

.dtqf-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px;
  min-height: 36px;
  border: none;
  background: none;
  border-radius: var(--r-sm, 10px);
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  color: var(--t-700, #3b4059);
  cursor: pointer;
  text-align: left;
}
.dtqf-item:hover { background: var(--bg-inset, #eff0f8); }
/* Fixed slot for the tick: without it, selecting an item shifts every label
   sideways and the list appears to jump. */
.dtqf-check {
  flex: none;
  width: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--accent, #6d5df6);
}
.dtqf-label { flex: 1 1; }
.dtqf-count {
  flex: none;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--t-500, #6c7189);
  background: var(--bg-inset, #eff0f8);
  border-radius: 999px;
  padding: 1px 8px;
  font-variant-numeric: tabular-nums;
}
/* An option matching nothing stays selectable — picking it and seeing an empty
   table is a real answer — but it should not read as equal to one that does. */
.dtqf-item.is-empty { color: var(--t-400, #9aa0b6); }
.dtqf-item.is-empty .dtqf-count { opacity: 0.65; }

.dtqf-item.active {
  background: var(--accent-soft, #ece9ff);
  color: var(--accent-ink, #5847d6);
  font-weight: 600;
}
.dtqf-item.active .dtqf-count { background: var(--surface, #fff); color: var(--accent-ink, #5847d6); }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;;yEAGuE;EACvE;;;;;;;;GAQC;EACD,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,SAAO;EACP,6FAA6F;EAC7F,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gEAAgE;EAChE,SAAS;EACT,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gEAAgE;EAChE,WAAW;EACX,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gEAAgE;EAChE,QAAQ;EACR,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE;;IAEE,mCAAmC;EACrC;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;;IAEE,mCAAmC;EACrC;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;;IAEE,mCAAmC;EACrC;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B;;6CAE2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE;;IAEE,qDAAqD;EACvD;;EAEA;IACE,0DAA0D;EAC5D;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,0DAA0D;EAC5D;AACF;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,OAAO;EACP,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,6DAA6D;EAC7D,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;IAEE,oDAAoD;EACtD;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,0DAA0D;EAC5D;AACF;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;IAEE,kEAAkE;EACpE;;EAEA;IACE,wEAAwE;EAC1E;AACF;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE;;IAEE,oDAAoD;EACtD;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,6DAA6D;EAC7D,2CAA2C;AAC7C;;AAEA;EACE;;IAEE,oDAAoD;EACtD;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE;;IAEE,qDAAqD;EACvD;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,6DAA6D;EAC7D,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,qDAAqD;EACvD;;EAEA;IACE,0DAA0D;EAC5D;AACF;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE;;IAEE,oDAAoD;EACtD;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,0DAA0D;EAC5D;AACF;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;IACE,0CAA0C;EAC5C;AACF;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ;;;;GAIC;EACD,0BAA0B;EAC1B,yBAAyB;EACzB;;6CAE2C;AAC7C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ;;;;GAIC;EACD,4CAA4C;EAC5C,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;0CAGwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,yCAAyC;EAC3C;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;;IAEE;;;;oCAIgC;EAClC;;EAEA;IACE;;;;sCAIkC;EACpC;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,OAAO;EACP,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,qDAAqD;AACvD;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,SAAS;EACT,qDAAqD;AACvD;;AAEA;EACE;;IAEE,YAAY;IACZ,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,uCAAuC;EACzC;AACF;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;;iDAEiD;;AAEjD,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,4CAA4C;EAC5C,8CAA8C;EAC9C,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,4DAA4D;EAC5D,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA,gEAAgE;AAChE;;;EAGE,aAAa;AACf;;AAEA;6CAC6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA,sDAAsD;AACtD;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,qCAAqC;EACrC,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8CAA8C;EAC9C,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gDAAgD;EAChD,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yFAAyF;EACzF,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE;;;;GAIC;EACD,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;iDAEiD;;AAEjD;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,4CAA4C;EAC5C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ;;;;GAIC;EACD,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;iDAEiD;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB;;;;GAIC;EACD,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;iDAEiD;;AAEjD;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,+BAA+B;EAC/B,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;EAGE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;;EAGE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,eAAe;AACf;;;mDAGmD;AACnD;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;;;;GAIC;EACD,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,MAAM;EACN,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA,wEAAwE;;AAExE,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB;;uCAEqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mCAAmC;EACnC,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mCAAmC;EACnC,yCAAyC;EACzC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA,yBAAyB;AACzB;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;IACI,qBAAqB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,oDAAoD;EACpD,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,iBAAiB;EACjB,oDAAoD;EACpD,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,wCAAwC;EACxC;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;;EAE1B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,6CAA6C;AAC7C;EACE,qCAAqC;EACrC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE,SAAO;AACT;;AAEA;;iDAEiD;;AAEjD,wBAAwB;AACxB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,OAAO;EACP,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;gDAEgD;;AAEhD;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,mEAAmE;EACnE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA,0BAA0B;AAC1B;;;;;EAKE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;EAIE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB;;wBAEsB;AACxB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B;;mBAEiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;;EAEE,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,qCAAqC;EACrC,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE;IACE,WAAW;EACb;AACF;;AAEA;;8CAE8C;;AAE9C,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB;AAClB;EACE,yCAAyC;EACzC,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,yCAAyC;EACzC,eAAe;EACf,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,yCAAyC;EACzC,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;EAC/B,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb;;mBAEiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,0BAA0B;EAC1B,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;iDAEiD;;AAEjD,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;;EAEE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qDAAqD;AACvD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,QAAQ;IACR,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;;;;;gCAKgC;AAChC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;;qEAKqE;AACrE,mBAAmB,kBAAkB,EAAE,oBAAoB,EAAE;;AAE7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,gCAAgC;EAChC,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;AACA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;AACA;2CAC2C;AAC3C;EACE,uCAAuC;EACvC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6CAA6C;EAC7C,oCAAoC;EACpC,UAAU;AACZ;AACA,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACnF;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;AACA,oBAAoB,0BAA0B,EAAE;;AAEhD,gBAAgB,YAAY,EAAE;AAC9B;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA,qEAAqE;AACrE;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;AACA,mBAAmB,oCAAoC,EAAE;AACzD;2CAC2C;AAC3C;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA,cAAc,SAAO,EAAE;AACvB;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;+EAC+E;AAC/E,sBAAsB,4BAA4B,EAAE;AACpD,kCAAkC,aAAa,EAAE;;AAEjD;EACE,uCAAuC;EACvC,iCAAiC;EACjC,gBAAgB;AAClB;AACA,gCAAgC,gCAAgC,EAAE,iCAAiC,EAAE","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  /* Reads the design-system token (redesign.css, imported after this file, so\n     its :root definition wins) with a literal fallback if that file is ever\n     absent. This previously named 'Inter', which index.html never loaded --\n     so the dashboard has in fact been rendering in the system UI font. */\n  font-family: var(\n    --font-sans,\n    \"Poppins\",\n    system-ui,\n    -apple-system,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif\n  );\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f5f5;\n}\n\n/* Split Layout Container */\n.auth-layout {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* Left Side - 3D Illustration */\n.auth-left {\n  flex: 1;\n  /* background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 30%, #a855f7 60%, #c084fc 100%); */\n  position: relative;\n  /* overflow: hidden; */\n}\n.auth-left img {\n  float: left;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.crypto-scene {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  perspective: 1000px;\n  transform-style: preserve-3d;\n}\n\n/* Gradient blobs for background depth */\n.gradient-blob {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(60px);\n  opacity: 0.6;\n}\n\n.blob-1 {\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(circle, #06b6d4 0%, transparent 70%);\n  top: -10%;\n  right: -10%;\n  animation: blobFloat1 15s ease-in-out infinite;\n}\n\n.blob-2 {\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(circle, #8b5cf6 0%, transparent 70%);\n  bottom: 10%;\n  left: -5%;\n  animation: blobFloat2 18s ease-in-out infinite;\n}\n\n.blob-3 {\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(circle, #ec4899 0%, transparent 70%);\n  top: 40%;\n  right: 20%;\n  animation: blobFloat3 12s ease-in-out infinite;\n}\n\n@keyframes blobFloat1 {\n  0%,\n  100% {\n    transform: translate(0, 0) scale(1);\n  }\n\n  33% {\n    transform: translate(-30px, 20px) scale(1.1);\n  }\n\n  66% {\n    transform: translate(20px, -30px) scale(0.9);\n  }\n}\n\n@keyframes blobFloat2 {\n  0%,\n  100% {\n    transform: translate(0, 0) scale(1);\n  }\n\n  50% {\n    transform: translate(40px, -20px) scale(1.15);\n  }\n}\n\n@keyframes blobFloat3 {\n  0%,\n  100% {\n    transform: translate(0, 0) scale(1);\n  }\n\n  50% {\n    transform: translate(-25px, 25px) scale(1.1);\n  }\n}\n\n/* 3D Crypto Coins */\n.crypto-coin {\n  position: absolute;\n  transform-style: preserve-3d;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n\n.coin-inner {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transform-style: preserve-3d;\n}\n\n.coin-face {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backface-visibility: hidden;\n  box-shadow:\n    0 10px 30px rgba(0, 0, 0, 0.3),\n    inset 0 2px 10px rgba(255, 255, 255, 0.3);\n}\n\n.coin-front {\n  transform: rotateY(0deg);\n}\n\n.coin-front span {\n  font-size: 24px;\n  font-weight: bold;\n  color: white;\n}\n\n.coin-front svg {\n  width: 60%;\n  height: 60%;\n}\n\n/* Ethereum Coin */\n.eth-coin {\n  width: 70px;\n  height: 70px;\n  top: 12%;\n  left: 15%;\n  animation: floatEth3D 8s infinite;\n}\n\n.eth-coin .coin-face {\n  background: linear-gradient(145deg, #627eea 0%, #3c4fd1 100%);\n  border: 3px solid rgba(255, 255, 255, 0.2);\n}\n\n@keyframes floatEth3D {\n  0%,\n  100% {\n    transform: translateY(0) rotateX(10deg) rotateY(0deg);\n  }\n\n  25% {\n    transform: translateY(-20px) rotateX(20deg) rotateY(15deg);\n  }\n\n  50% {\n    transform: translateY(-10px) rotateX(5deg) rotateY(30deg);\n  }\n\n  75% {\n    transform: translateY(-25px) rotateX(15deg) rotateY(15deg);\n  }\n}\n\n/* Bitcoin Coin */\n.btc-coin {\n  width: 55px;\n  height: 55px;\n  top: 8%;\n  right: 25%;\n  animation: floatBtc3D 9s infinite;\n}\n\n.btc-coin .coin-face {\n  background: linear-gradient(145deg, #f7931a 0%, #c77700 100%);\n  border: 3px solid rgba(255, 255, 255, 0.25);\n}\n\n.btc-coin .coin-front span {\n  font-size: 28px;\n}\n\n@keyframes floatBtc3D {\n  0%,\n  100% {\n    transform: translateY(0) rotateX(5deg) rotateY(0deg);\n  }\n\n  30% {\n    transform: translateY(-15px) rotateX(-10deg) rotateY(-20deg);\n  }\n\n  60% {\n    transform: translateY(-25px) rotateX(10deg) rotateY(10deg);\n  }\n}\n\n/* USDT Coin */\n.usdt-coin {\n  width: 50px;\n  height: 50px;\n  top: 28%;\n  left: 5%;\n  animation: floatUsdt3D 7s infinite;\n}\n\n.usdt-coin .coin-face {\n  background: linear-gradient(145deg, #26a17b 0%, #1a7a5c 100%);\n  border: 3px solid rgba(255, 255, 255, 0.2);\n}\n\n.usdt-coin .coin-front span {\n  font-size: 22px;\n}\n\n@keyframes floatUsdt3D {\n  0%,\n  100% {\n    transform: translateY(0) rotateX(0deg) rotateY(0deg) rotateZ(0deg);\n  }\n\n  50% {\n    transform: translateY(-18px) rotateX(15deg) rotateY(25deg) rotateZ(5deg);\n  }\n}\n\n/* Solana Coin */\n.sol-coin {\n  width: 60px;\n  height: 60px;\n  top: 45%;\n  left: 8%;\n  animation: floatSol3D 10s infinite;\n}\n\n.sol-coin .coin-face {\n  background: linear-gradient(145deg, #9945ff 0%, #14f195 100%);\n  border: 3px solid rgba(255, 255, 255, 0.2);\n}\n\n@keyframes floatSol3D {\n  0%,\n  100% {\n    transform: translateY(0) rotateX(5deg) rotateY(0deg);\n  }\n\n  33% {\n    transform: translateY(-22px) rotateX(-15deg) rotateY(20deg);\n  }\n\n  66% {\n    transform: translateY(-12px) rotateX(10deg) rotateY(-15deg);\n  }\n}\n\n/* BNB Coin */\n.bnb-coin {\n  width: 55px;\n  height: 55px;\n  top: 38%;\n  right: 12%;\n  animation: floatBnb3D 8.5s infinite;\n}\n\n.bnb-coin .coin-face {\n  background: linear-gradient(145deg, #f3ba2f 0%, #c99a00 100%);\n  border: 3px solid rgba(255, 255, 255, 0.25);\n}\n\n@keyframes floatBnb3D {\n  0%,\n  100% {\n    transform: translateY(0) rotateX(0deg) rotateY(0deg);\n  }\n\n  40% {\n    transform: translateY(-20px) rotateX(20deg) rotateY(-25deg);\n  }\n\n  80% {\n    transform: translateY(-10px) rotateX(-10deg) rotateY(15deg);\n  }\n}\n\n/* Matic/Polygon Coin */\n.matic-coin {\n  width: 50px;\n  height: 50px;\n  top: 18%;\n  left: 35%;\n  animation: floatMatic3D 9.5s infinite;\n}\n\n.matic-coin .coin-face {\n  background: linear-gradient(145deg, #8247e5 0%, #5a2eb8 100%);\n  border: 3px solid rgba(255, 255, 255, 0.2);\n}\n\n@keyframes floatMatic3D {\n  0%,\n  100% {\n    transform: translateY(0) rotateX(10deg) rotateY(5deg);\n  }\n\n  50% {\n    transform: translateY(-30px) rotateX(-5deg) rotateY(-20deg);\n  }\n}\n\n/* Red/Orange Coin (like in screenshot) */\n.red-coin {\n  width: 80px;\n  height: 40px;\n  top: 40%;\n  right: 28%;\n  animation: floatRed3D 7.5s infinite;\n}\n\n.red-coin .coin-face {\n  background: linear-gradient(145deg, #ef4444 0%, #b91c1c 100%);\n  border: 3px solid rgba(255, 255, 255, 0.15);\n  border-radius: 50%;\n  transform: rotateX(60deg);\n}\n\n@keyframes floatRed3D {\n  0%,\n  100% {\n    transform: translateY(0) rotateX(60deg) rotateZ(0deg);\n  }\n\n  50% {\n    transform: translateY(-15px) rotateX(70deg) rotateZ(10deg);\n  }\n}\n\n/* Avalanche Coin */\n.avax-coin {\n  width: 55px;\n  height: 55px;\n  bottom: 20%;\n  right: 18%;\n  animation: floatAvax3D 8s infinite;\n}\n\n.avax-coin .coin-face {\n  background: linear-gradient(145deg, #e84142 0%, #b52f30 100%);\n  border: 3px solid rgba(255, 255, 255, 0.2);\n}\n\n@keyframes floatAvax3D {\n  0%,\n  100% {\n    transform: translateY(0) rotateX(5deg) rotateY(0deg);\n  }\n\n  35% {\n    transform: translateY(-18px) rotateX(-10deg) rotateY(20deg);\n  }\n\n  70% {\n    transform: translateY(-8px) rotateX(15deg) rotateY(-10deg);\n  }\n}\n\n/* Stacked Coins Platform */\n.coin-stack {\n  position: absolute;\n  bottom: 18%;\n  left: 12%;\n  transform-style: preserve-3d;\n  animation: stackFloat 6s ease-in-out infinite;\n}\n\n.stack-coin {\n  width: 70px;\n  height: 20px;\n  border-radius: 35px;\n  position: absolute;\n  transform: rotateX(60deg);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.stack-1 {\n  background: linear-gradient(90deg, #8b5cf6 0%, #6d28d9 100%);\n  bottom: 0;\n}\n\n.stack-2 {\n  background: linear-gradient(90deg, #a78bfa 0%, #7c3aed 100%);\n  bottom: 8px;\n}\n\n.stack-3 {\n  background: linear-gradient(90deg, #c4b5fd 0%, #8b5cf6 100%);\n  bottom: 16px;\n}\n\n@keyframes stackFloat {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n/* Chain/Link Icon */\n.chain-icon {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  top: 50%;\n  left: 45%;\n  animation: chainFloat 7s ease-in-out infinite;\n  opacity: 0.8;\n}\n\n.chain-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n@keyframes chainFloat {\n  0%,\n  100% {\n    transform: translateY(0) rotate(0deg);\n  }\n\n  50% {\n    transform: translateY(-15px) rotate(10deg);\n  }\n}\n\n/* Central Platform */\n.central-platform {\n  position: absolute;\n  bottom: 25%;\n  left: 50%;\n  transform: translateX(-50%);\n  transform-style: preserve-3d;\n  animation: platformFloat 5s ease-in-out infinite;\n}\n\n.platform-3d {\n  position: relative;\n  transform-style: preserve-3d;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.platform-top {\n  width: 160px;\n  height: 80px;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0.25) 0%,\n    rgba(255, 255, 255, 0.1) 100%\n  );\n  border-radius: 80px / 40px;\n  transform: rotateX(60deg);\n  box-shadow:\n    0 20px 50px rgba(0, 0, 0, 0.3),\n    inset 0 2px 10px rgba(255, 255, 255, 0.3);\n}\n\n.platform-side {\n  width: 160px;\n  height: 30px;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0.15) 0%,\n    rgba(255, 255, 255, 0.05) 100%\n  );\n  border-radius: 0 0 80px 80px / 0 0 20px 20px;\n  position: absolute;\n  top: 35px;\n  transform-origin: top;\n  transform: rotateX(-30deg);\n}\n\n.maxel-logo {\n  position: absolute;\n  top: -50px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 70px;\n  height: 70px;\n  background: linear-gradient(145deg, #1a1a2e 0%, #0f0f1a 100%);\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow:\n    0 15px 35px rgba(0, 0, 0, 0.4),\n    0 5px 15px rgba(0, 0, 0, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  animation: logoGlow 4s ease-in-out infinite;\n}\n\n.maxel-logo span {\n  font-size: 32px;\n  font-weight: bold;\n  color: white;\n  text-shadow: 0 0 10px rgba(139, 92, 246, 0.5);\n}\n\n@keyframes platformFloat {\n  0%,\n  100% {\n    transform: translateX(-50%) translateY(0);\n  }\n\n  50% {\n    transform: translateX(-50%) translateY(-12px);\n  }\n}\n\n@keyframes logoGlow {\n  0%,\n  100% {\n    box-shadow:\n      0 15px 35px rgba(0, 0, 0, 0.4),\n      0 5px 15px rgba(0, 0, 0, 0.3),\n      inset 0 1px 0 rgba(255, 255, 255, 0.1),\n      0 0 20px rgba(139, 92, 246, 0);\n  }\n\n  50% {\n    box-shadow:\n      0 15px 35px rgba(0, 0, 0, 0.4),\n      0 5px 15px rgba(0, 0, 0, 0.3),\n      inset 0 1px 0 rgba(255, 255, 255, 0.1),\n      0 0 40px rgba(139, 92, 246, 0.4);\n  }\n}\n\n/* Floating Particles */\n.particle {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 50%;\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);\n}\n\n.particle-1 {\n  top: 8%;\n  left: 25%;\n  animation: particleFloat 4s ease-in-out infinite;\n}\n\n.particle-2 {\n  top: 15%;\n  right: 15%;\n  animation: particleFloat 5s ease-in-out infinite 0.5s;\n}\n\n.particle-3 {\n  top: 55%;\n  left: 3%;\n  animation: particleFloat 4.5s ease-in-out infinite 1s;\n}\n\n.particle-4 {\n  bottom: 30%;\n  left: 35%;\n  animation: particleFloat 5.5s ease-in-out infinite 1.5s;\n}\n\n.particle-5 {\n  bottom: 15%;\n  right: 25%;\n  animation: particleFloat 4s ease-in-out infinite 2s;\n}\n\n.particle-6 {\n  top: 35%;\n  left: 50%;\n  animation: particleFloat 6s ease-in-out infinite 0.8s;\n}\n\n.particle-7 {\n  top: 22%;\n  right: 35%;\n  animation: particleFloat 4.5s ease-in-out infinite 1.2s;\n}\n\n.particle-8 {\n  bottom: 45%;\n  right: 8%;\n  animation: particleFloat 5s ease-in-out infinite 0.3s;\n}\n\n@keyframes particleFloat {\n  0%,\n  100% {\n    opacity: 0.4;\n    transform: translateY(0) scale(1);\n  }\n\n  50% {\n    opacity: 1;\n    transform: translateY(-20px) scale(1.5);\n  }\n}\n\n/* Right Side - Form */\n.auth-right {\n  flex: 1;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n}\n\n.auth-form-container {\n  width: 100%;\n  max-width: 420px;\n}\n\n/* Icon at top */\n.auth-icon {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #f3e8ff, #e9d5ff);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px;\n}\n\n.auth-icon svg {\n  width: 40px;\n  height: 40px;\n  color: #8b5cf6;\n}\n\n.auth-icon-inner {\n  font-size: 32px;\n}\n\n/* Title */\n.auth-title {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.auth-title h2 {\n  color: #1a1a2e;\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  line-height: 1.3;\n}\n\n.auth-title p {\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Form Elements */\n.form-row {\n  display: flex;\n  gap: 12px;\n}\n\n.form-row .form-group {\n  flex: 1;\n}\n\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-group label {\n  display: block;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 14px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  font-size: 15px;\n  transition: all 0.2s;\n  background: #f9fafb;\n  font-family: var(--iv-sans);\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #8b5cf6;\n  background: var(--bg-primary);\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);\n}\n\n.form-group input::placeholder {\n  color: #9ca3af;\n}\n\n.form-group input.error {\n  border-color: #ef4444;\n}\n\n.input-wrapper {\n  position: relative;\n}\n\n.input-wrapper .toggle-password {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #9ca3af;\n  padding: 0;\n}\n\n.error-message {\n  color: #ef4444;\n  font-size: 12px;\n  margin-top: 6px;\n}\n\n/* Checkbox */\n.checkbox-group {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #8b5cf6;\n  margin-top: 2px;\n  cursor: pointer;\n}\n\n.checkbox-group label {\n  font-size: 13px;\n  color: #6b7280;\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.checkbox-group label a {\n  color: #8b5cf6;\n  text-decoration: none;\n}\n\n.checkbox-group label a:hover {\n  text-decoration: underline;\n}\n\n/* Buttons */\n.btn {\n  width: 100%;\n  padding: 14px 24px;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.login-btn {\n  width: 100%;\n  padding: 14px 24px;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #8b5cf6, #7c3aed);\n  color: white;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #8b5cf6, #7c3aed);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, #7c3aed, #6d28d9);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);\n}\n\n.btn-primary:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.btn-google {\n  background: #ffffff;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  margin-top: 16px;\n}\n\n.btn-google:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n}\n\n.btn-google img {\n  width: 20px;\n  height: 20px;\n}\n\n/* Divider */\n.divider {\n  display: flex;\n  align-items: center;\n  margin: 24px 0;\n}\n\n.divider::before,\n.divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: #e5e7eb;\n}\n\n.divider span {\n  padding: 0 16px;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n/* Auth Links */\n.auth-links {\n  text-align: center;\n  margin-top: 24px;\n}\n\n.auth-links p {\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.auth-links a {\n  color: #8b5cf6;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.auth-links a:hover {\n  text-decoration: underline;\n}\n\n/* Alert Messages */\n.alert {\n  padding: 14px 16px;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.alert-error {\n  background-color: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n.alert-success {\n  background-color: #f0fdf4;\n  color: #16a34a;\n  border: 1px solid #bbf7d0;\n}\n\n/* OTP Input */\n.otp-container {\n  text-align: center;\n}\n\n.otp-container > p {\n  color: #6b7280;\n  margin-bottom: 24px;\n  font-size: 15px;\n  line-height: 1.6;\n}\n\n.otp-container .email-highlight {\n  color: #8b5cf6;\n  font-weight: 600;\n}\n\n.otp-input-group {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.otp-input {\n  width: 52px;\n  height: 58px;\n  text-align: center;\n  font-size: 24px;\n  font-weight: 600;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #f9fafb;\n  transition: all 0.2s;\n}\n\n.otp-input:focus {\n  outline: none;\n  border-color: #8b5cf6;\n  background: #ffffff;\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);\n}\n\n.resend-otp {\n  margin-top: 20px;\n}\n\n.resend-otp span {\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.timer {\n  color: #8b5cf6;\n  font-weight: 600;\n}\n\n.btn-link {\n  background: none;\n  border: none;\n  color: #8b5cf6;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  font-size: 14px;\n}\n\n.btn-link:hover {\n  text-decoration: underline;\n}\n\n.back-link {\n  display: inline-block;\n  margin-top: 20px;\n  color: #6b7280;\n  font-size: 14px;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.back-link:hover {\n  color: #8b5cf6;\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 0.8s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Dashboard Styles */\n.dashboard-container {\n  min-height: 100vh;\n  background: #f5f5f5;\n}\n\n.dashboard-header {\n  background: linear-gradient(135deg, #8b5cf6, #7c3aed);\n  color: white;\n  padding: 20px 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dashboard-header h1 {\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.dashboard-header .btn {\n  width: auto;\n  padding: 10px 20px;\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.dashboard-header .btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.dashboard-content {\n  padding: 40px;\n}\n\n.welcome-card {\n  background: white;\n  border-radius: 16px;\n  padding: 40px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.welcome-card h2 {\n  color: #1a1a2e;\n  margin-bottom: 16px;\n  font-size: 28px;\n}\n\n.welcome-card > p {\n  color: #6b7280;\n  margin-bottom: 8px;\n}\n\n.user-info {\n  margin-top: 24px;\n  padding: 24px;\n  background: #f9fafb;\n  border-radius: 12px;\n}\n\n.user-info p {\n  margin-bottom: 12px;\n  color: #6b7280;\n}\n\n.user-info p:last-child {\n  margin-bottom: 0;\n}\n\n.user-info strong {\n  color: #1a1a2e;\n}\n\n/* Responsive */\n@media (max-width: 968px) {\n  .auth-layout {\n    flex-direction: column;\n  }\n\n  .auth-left {\n    min-height: 350px;\n  }\n\n  .auth-right {\n    padding: 30px 20px;\n  }\n\n  .central-platform {\n    bottom: 20%;\n  }\n}\n\n@media (max-width: 480px) {\n  .auth-left {\n    display: none;\n  }\n\n  .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .otp-input {\n    width: 45px;\n    height: 50px;\n    font-size: 20px;\n  }\n\n  .otp-input-group {\n    gap: 8px;\n  }\n}\n\n/* ============================================\n   DASHBOARD LAYOUT STYLES\n   ============================================ */\n\n/* CSS Variables for theming */\n:root {\n  --bg-primary: #ffffff;\n  --bg-secondary: #f8fafc;\n  --bg-tertiary: #f1f5f9;\n  --text-primary: #1e293b;\n  --text-secondary: #64748b;\n  --text-muted: #94a3b8;\n  --border-color: #e2e8f0;\n  --accent-primary: #8b5cf6;\n  --accent-secondary: #7c3aed;\n  --success: #10b981;\n  --warning: #f59e0b;\n  --danger: #ef4444;\n  --info: #3b82f6;\n  --sidebar-width: 260px;\n  --sidebar-collapsed-width: 70px;\n  --header-height: 70px;\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 16px;\n}\n\n/* Dark theme */\n[data-theme=\"dark\"] {\n  --bg-primary: #0f172a;\n  --bg-secondary: #1e293b;\n  --bg-tertiary: #334155;\n  --text-primary: #f1f5f9;\n  --text-secondary: #94a3b8;\n  --text-muted: #64748b;\n  --border-color: #334155;\n}\n\n/* Dashboard Layout */\n.dashboard-layout {\n  display: flex;\n  min-height: 100vh;\n  background: var(--bg-secondary);\n}\n\n.dashboard-layout.sidebar-collapsed .sidebar {\n  width: var(--sidebar-collapsed-width);\n}\n\n.dashboard-layout.sidebar-collapsed .main-content {\n  margin-left: var(--sidebar-collapsed-width);\n}\n\n.main-content {\n  flex: 1;\n  margin-left: var(--sidebar-width);\n  transition: margin-left 0.3s ease;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.page-content {\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto;\n}\n\n/* Test Mode Ribbon */\n.test-mode-ribbon {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);\n  color: #ffffff;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  z-index: 900;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);\n}\n\n.test-mode-ribbon span:first-child {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.test-mode-ribbon .ribbon-info {\n  font-weight: 400;\n  opacity: 0.95;\n}\n\n/* Adjust layout when test mode ribbon is shown */\n.dashboard-layout:has(.test-mode-ribbon) .sidebar {\n  top: 40px;\n  height: calc(100vh - 40px);\n}\n\n.dashboard-layout:has(.test-mode-ribbon) .main-content {\n  padding-top: 40px;\n}\n\n.dashboard-layout:has(.test-mode-ribbon) .header {\n  top: 40px;\n}\n\n/* Ensure drawers and modals appear above the test mode ribbon */\n.dashboard-layout:has(.test-mode-ribbon) .drawer-overlay,\n.dashboard-layout:has(.test-mode-ribbon) .drawer,\n.dashboard-layout:has(.test-mode-ribbon) .modal-overlay {\n  z-index: 1000;\n}\n\n/* Onboarding deep-link return banner (shown on Invoices/Developer when the\n   merchant arrives from the setup wizard). */\n.onboarding-return-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  background: #f7f5fd;\n  border: 1px solid #e6e0fa;\n  border-radius: var(--radius-md, 10px);\n  color: var(--text-secondary, #64748b);\n  font-size: 14px;\n}\n\n.onboarding-return-btn {\n  background: linear-gradient(135deg, #8b5cf6, #7c3aed);\n  color: #fff;\n  border: none;\n  border-radius: var(--radius-sm, 6px);\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.onboarding-return-btn:hover {\n  background: linear-gradient(135deg, #7c3aed, #6d28d9);\n}\n\n/* Dashboard onboarding card (activation + go-live). */\n.onboarding-card {\n  background: var(--bg-primary, #fff);\n  border: 1px solid var(--border-color, #e2e8f0);\n  border-radius: var(--radius-lg, 16px);\n  box-shadow: var(--shadow-sm, 0 1px 2px 0 rgba(0, 0, 0, 0.05));\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.onboarding-card-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 96px;\n}\n\n.onboarding-card-loading-text {\n  color: var(--text-muted, #94a3b8);\n  font-size: 14px;\n}\n\n.onboarding-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.onboarding-card-head h2 {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary, #1e293b);\n}\n\n.onboarding-card-head p {\n  margin-top: 4px;\n  font-size: 14px;\n  color: var(--text-secondary, #64748b);\n}\n\n.onboarding-card-cta {\n  width: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.activation-progress {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary, #64748b);\n  margin-bottom: 12px;\n}\n\n/* Go-live checklist (success screen + dashboard). */\n.golive-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.golive-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border: 1px solid var(--border-color, #e2e8f0);\n  border-radius: var(--radius-md, 10px);\n  background: var(--bg-primary, #fff);\n}\n\n.golive-marker {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 1.5px solid var(--border-color, #e2e8f0);\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.golive-item.done .golive-marker {\n  background: var(--success, #10b981);\n  border-color: transparent;\n}\n\n.golive-label {\n  flex: 1;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--text-primary, #1e293b);\n}\n\n.golive-item.done .golive-label {\n  color: var(--text-secondary, #64748b);\n  text-decoration: line-through;\n}\n\n.golive-action {\n  background: none;\n  border: none;\n  color: var(--accent-secondary, #7c3aed);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  font-family: var(--iv-sans);\n}\n\n.golive-action:hover {\n  text-decoration: underline;\n}\n\n.wiz-success-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 20px;\n  border-radius: 50%;\n  background: #ecfdf5;\n  color: var(--success, #10b981);\n}\n\n/* Loading Container */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  gap: 16px;\n}\n\n.loading-spinner.large {\n  width: 40px;\n  height: 40px;\n  border-width: 3px;\n  border-color: var(--border-color);\n  border-top-color: var(--accent-primary);\n}\n\n.loading-spinner.small {\n  width: 16px;\n  height: 16px;\n  border-width: 2px;\n}\n\n/* ============================================\n   SIDEBAR STYLES\n   ============================================ */\n\n.sidebar {\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: var(--sidebar-width);\n  background: var(--bg-primary);\n  border-right: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s ease;\n  z-index: 100;\n}\n\n.sidebar.collapsed {\n  width: var(--sidebar-collapsed-width);\n}\n\n.sidebar.collapsed .logo-text,\n.sidebar.collapsed .nav-item span,\n.sidebar.collapsed .version-info {\n  display: none;\n}\n\n.sidebar.collapsed .logo {\n  justify-content: center;\n}\n\n.sidebar.collapsed .nav-item {\n  justify-content: center;\n  padding: 12px;\n}\n\n.sidebar-header {\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--border-color);\n  height: 70px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.logo img {\n  max-width: 170px;\n  padding: 8px;\n  background-color: #fff;\n}\n.logo-icon {\n  width: 40px;\n  height: 40px;\n  /* background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary)); */\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 700;\n  font-size: 18px;\n}\n.logo-icon img {\n  padding-right: 8px;\n  max-width: 40px;\n  margin-left: -14px;\n  margin-top: 6px;\n}\n.logo img.mobile_xl {\n  display: none;\n}\n.sidebar-collapsed .sidebar-header {\n  padding-bottom: 9px;\n}\n.logo-text {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.collapse-btn {\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.collapse-btn:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 16px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: var(--radius-md);\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.nav-item:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.nav-item.active {\n  background: linear-gradient(\n    135deg,\n    rgba(139, 92, 246, 0.1),\n    rgba(124, 58, 237, 0.1)\n  );\n  color: var(--accent-primary);\n}\n\n.nav-item.active::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  width: 3px;\n  height: 24px;\n  background: var(--accent-primary);\n  border-radius: 0 3px 3px 0;\n}\n\n.sidebar-footer {\n  padding: 16px 20px;\n  border-top: 1px solid var(--border-color);\n}\n.sidebar-collapsed .sidebar-footer {\n  display: none;\n}\n.version-info {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n/* ============================================\n   HEADER STYLES\n   ============================================ */\n\n.dashboard-header {\n  height: var(--header-height);\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-color);\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.page-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Mode Toggle */\n.mode-toggle {\n  position: relative;\n  display: flex;\n  background: var(--bg-secondary);\n  border-radius: 20px;\n  padding: 4px;\n}\n\n.mode-btn {\n  padding: 6px 16px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 16px;\n  position: relative;\n  z-index: 1;\n  transition: color 0.2s;\n}\n\n.mode-btn.active {\n  color: white;\n}\n\n.mode-btn-purple {\n  padding: 8px 16px;\n  border: none;\n  background: linear-gradient(\n    135deg,\n    var(--accent-primary),\n    var(--accent-secondary)\n  );\n  color: white;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.mode-btn-purple:hover {\n  background: linear-gradient(\n    135deg,\n    var(--accent-primary),\n    var(--accent-secondary)\n  );\n}\n\n.mode-slider {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: calc(50% - 4px);\n  height: calc(100% - 8px);\n  background: var(--accent-primary);\n  border-radius: 16px;\n  transition: transform 0.3s ease;\n}\n\n.mode-slider.live {\n  transform: translateX(100%);\n  background: var(--success);\n}\n\n/* Icon Buttons */\n.icon-btn {\n  width: 40px;\n  height: 40px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.icon-btn:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border-color: var(--text-muted);\n}\n\n.notification-btn {\n  position: relative;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 18px;\n  height: 18px;\n  background: var(--danger);\n  color: white;\n  font-size: 10px;\n  font-weight: 600;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Profile Dropdown */\n.profile-dropdown {\n  position: relative;\n}\n\n.profile-btn {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  background: var(--bg-primary);\n  cursor: pointer;\n  transition: all 0.2s;\n  font-family: var(--iv-sans);\n}\n\n.profile-btn:hover {\n  background: var(--bg-secondary);\n  border-color: var(--text-muted);\n}\n\n.avatar {\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(\n    135deg,\n    var(--accent-primary),\n    var(--accent-secondary)\n  );\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.profile-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.profile-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.profile-email {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.profile-btn svg {\n  color: var(--text-muted);\n  transition: transform 0.2s;\n}\n\n.profile-btn svg.rotate {\n  transform: rotate(180deg);\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 200px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-lg);\n  padding: 8px;\n  z-index: 100;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 14px;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  transition: all 0.2s;\n  font-family: var(--iv-sans);\n}\n\n.dropdown-item:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.dropdown-item.logout {\n  color: var(--danger);\n}\n\n.dropdown-item.logout:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.dropdown-divider {\n  height: 1px;\n  background: var(--border-color);\n  margin: 8px 0;\n}\n\n/* ============================================\n   PAGE HEADER STYLES\n   ============================================ */\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n}\n\n.page-header h1 {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.page-header p {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n/* ============================================\n   BUTTON STYLES\n   ============================================ */\n\n.btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: linear-gradient(\n    135deg,\n    var(--accent-primary),\n    var(--accent-secondary)\n  );\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  width: auto;\n  font-family: var(--iv-sans);\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);\n}\n\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  width: auto;\n  font-family: var(--iv-sans);\n}\n\n.btn-secondary:hover {\n  background: var(--bg-secondary);\n  border-color: var(--text-muted);\n}\n\n/* ============================================\n   CARD STYLES\n   ============================================ */\n\n.card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  /* overflow: hidden; */\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.card-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.view-all {\n  font-size: 14px;\n  color: var(--accent-primary);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.view-all:hover {\n  text-decoration: underline;\n}\n\n.card-body {\n  padding: 20px 24px;\n}\n\n/* ============================================\n   HOME PAGE STYLES\n   ============================================ */\n\n.home-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.test-mode-banner {\n  padding: 12px 16px;\n  background: rgba(139, 92, 246, 0.1);\n  border: 1px solid rgba(139, 92, 246, 0.2);\n  border-radius: var(--radius-md);\n}\n\n.test-mode-banner span {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--accent-primary);\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.test-mode-banner p {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n.stat-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.stat-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  flex-shrink: 0;\n}\n\n.stat-content {\n  flex: 1;\n}\n\n.stat-title {\n  display: block;\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n}\n\n.stat-value {\n  display: block;\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.stat-change {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 20px;\n}\n\n.stat-change.positive {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--success);\n}\n\n.stat-change.negative {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger);\n}\n\n/* Dashboard Grid */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 20px;\n}\n\n.dashboard-grid .recent-transactions {\n  grid-row: span 2;\n}\n\n/* Recent Transactions */\n.transaction-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.transaction-item:last-child {\n  border-bottom: none;\n}\n\n.transaction-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n}\n\n.transaction-icon .incoming {\n  color: var(--success);\n}\n\n.transaction-icon .outgoing {\n  color: var(--danger);\n}\n\n.transaction-details {\n  flex: 1;\n}\n\n.transaction-title {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.transaction-date {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.transaction-amount {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.transaction-amount.incoming {\n  color: var(--success);\n}\n\n.transaction-amount.outgoing {\n  color: var(--danger);\n}\n\n/* Quick Actions */\n.quick-actions .card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.action-btn:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n/* Balance Overview */\n.balance-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.balance-item:last-child {\n  border-bottom: none;\n}\n\n.balance-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.balance-icon.btc {\n  background: linear-gradient(145deg, #f7931a, #c77700);\n}\n\n.balance-icon.eth {\n  background: linear-gradient(145deg, #627eea, #3c4fd1);\n}\n\n.balance-icon.usdt {\n  background: linear-gradient(145deg, #26a17b, #1a7a5c);\n}\n\n.balance-details {\n  flex: 1;\n}\n\n.crypto-name {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.crypto-balance {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.balance-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Empty State */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n.empty-state svg {\n  /* margin-bottom: 16px; */\n  /* opacity: 0.5; */\n}\n\n.empty-state p {\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n}\n\n.empty-state span {\n  font-size: 14px;\n}\n\n/* ============================================\n   STATS ROW\n   ============================================ */\n\n.stats-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.stat-item {\n  flex: 1;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 16px 20px;\n}\n\n.stat-label {\n  display: block;\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n}\n\n.stat-item .stat-value {\n  font-size: 20px;\n}\n\n.stat-item .stat-value.positive {\n  color: var(--success);\n}\n\n.stat-item .stat-value.negative {\n  color: var(--danger);\n}\n\n/* ============================================\n   DATA TABLE STYLES\n   ============================================ */\n\n.data-table-container {\n  width: 100%;\n}\n.payment-links-page .card .data-table-container {\n  overflow: scroll;\n}\n.table-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-color);\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.controls-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.controls-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-box .search {\n  position: absolute;\n  left: 12px;\n  color: var(--text-muted);\n}\n\n.search-box input {\n  padding: 10px 36px 10px 40px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 14px;\n  width: 250px;\n  transition: all 0.2s;\n}\n\n.search-box input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  background: var(--bg-primary);\n}\n\n.clear-search {\n  position: absolute;\n  right: 10px;\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 4px;\n}\n\n.date-filter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  min-width: 250px;\n}\n\n.date-filter input {\n  color: var(--text-primary) !important;\n  -webkit-text-fill-color: var(--text-primary) !important;\n}\n\n.date-picker-input {\n  border: none;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 14px;\n  width: 200px;\n  outline: none;\n}\n\n.filter-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n}\n\n.filter-btn:hover,\n.filter-btn.active {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.filter-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  width: 8px;\n  height: 8px;\n  background: var(--accent-primary);\n  border-radius: 50%;\n}\n\n/* Inline Filter Styles */\n.inline-filter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n}\n\n.inline-filter svg {\n  flex-shrink: 0;\n  color: var(--text-secondary);\n}\n\n.inline-filter-select {\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  color: var(--text-primary);\n  cursor: pointer;\n  outline: none;\n  padding-right: 8px;\n}\n\n.inline-filter-select:focus {\n  outline: none;\n}\n\n.clear-filters-btn {\n  background: none;\n  border: none;\n  color: var(--accent-primary);\n  font-size: 14px;\n  cursor: pointer;\n  padding: 8px 12px;\n}\n\n.clear-filters-btn:hover {\n  text-decoration: underline;\n}\n\n.results-count {\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.column-filters {\n  display: flex;\n  gap: 16px;\n  padding: 16px 20px;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n  flex-wrap: wrap;\n}\n\n.filter-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.filter-item label {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.filter-item select {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 14px;\n  min-width: 150px;\n}\n\n/* .table-wrapper {\n  overflow-x: auto;\n  overflow-y: visible;\n} */\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  overflow: scroll;\n}\n.data-table th {\n  text-align: left;\n  padding: 14px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-muted);\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n  white-space: nowrap;\n}\n\n.data-table th.sortable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.data-table th.sortable:hover {\n  color: var(--text-primary);\n}\n\n.data-table th.sorted {\n  color: var(--accent-primary);\n}\n\n.th-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sort-icons {\n  display: flex;\n  flex-direction: column;\n  gap: -2px;\n}\n\n.sort-icons svg {\n  color: var(--text-muted);\n  opacity: 0.3;\n}\n\n.sort-icons svg.active {\n  color: var(--accent-primary);\n  opacity: 1;\n}\n\n.data-table td {\n  padding: 16px;\n  font-size: 14px;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border-color);\n  vertical-align: middle;\n}\n\n.data-table tr:hover {\n  background: var(--bg-secondary);\n}\n\n.data-table tr.clickable {\n  cursor: pointer;\n}\n\n.data-table tr.empty-row:hover {\n  background: transparent;\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.status-badge.active,\n.status-badge.completed,\n.status-badge.paid {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--success);\n}\n\n.status-badge.pending {\n  background: rgba(245, 158, 11, 0.1);\n  color: var(--warning);\n}\n\n.status-badge.inactive,\n.status-badge.failed,\n.status-badge.cancelled {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger);\n}\n\n.status-badge.overdue {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger);\n}\n\n.status-badge.draft {\n  background: var(--bg-secondary);\n  color: var(--text-muted);\n}\n\n/* Type Badge */\n/* Scoped to the public invoice page. Unscoped, this also matched the\n   dashboard's Recent-invoices rows, where width: 100% on a flex-shrink: 0\n   column collapsed the name/ID column to zero and the status/amount/date\n   group rendered on top of the overflowing name. */\n.public-invoice-page .invoice-meta {\n  width: 100%;\n  text-align: right;\n}\n.invoice-meta span.status-badge.partially_paid {\n  color: #fef4c6;\n}\n.type-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.type-badge.incoming {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--success);\n}\n\n.type-badge.outgoing {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger);\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.action-icon-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.action-icon-btn:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.action-icon-btn.danger:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger);\n}\n\n/* Action Dropdown Menu */\n.action-dropdown {\n  position: relative;\n}\n\n.action-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 160px;\n  z-index: 9999;\n  padding: 0.25rem 0;\n}\n\n.action-dropdown-menu .dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  background: none;\n  color: var(--text-primary);\n  font-size: 14px;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.2s;\n}\n\n.action-dropdown-menu .dropdown-item:hover {\n  background: var(--bg-secondary);\n}\n\n.action-dropdown-menu .dropdown-item.danger {\n  color: var(--danger);\n}\n\n.action-dropdown-menu .dropdown-item.danger:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n/* Pagination */\n.table-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-top: 1px solid var(--border-color);\n}\n\n.pagination-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.page-size-select {\n  padding: 6px 10px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 14px;\n}\n\n.pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pagination-btn {\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  font-size: 14px;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n  background: var(--bg-primary);\n}\n\n.pagination-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.page-numbers {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0 4px;\n}\n\n.page-number {\n  min-width: 36px;\n  height: 36px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.page-number:hover:not(.active) {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.page-number.active {\n  background: var(--accent-primary);\n  color: white;\n  border-color: var(--accent-primary);\n}\n\n.page-ellipsis {\n  padding: 0 8px;\n  color: var(--text-muted);\n  font-size: 14px;\n}\n\n/* ============================================\n   BALANCE PAGE STYLES\n   ============================================ */\n\n.balance-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.refresh-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.total-balance-card {\n  background: linear-gradient(\n    135deg,\n    var(--accent-primary),\n    var(--accent-secondary)\n  );\n  border-radius: var(--radius-lg);\n  padding: 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n}\n\n.total-balance-info .label {\n  display: block;\n  font-size: 14px;\n  opacity: 0.8;\n  margin-bottom: 8px;\n}\n\n.total-balance-info .value {\n  display: block;\n  font-size: 36px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.total-balance-info .change {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.total-balance-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.total-balance-actions .btn-primary {\n  background: white;\n  color: var(--accent-primary);\n}\n\n.total-balance-actions .btn-secondary {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: white;\n}\n\n.balance-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 4px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  width: fit-content;\n}\n\n.balance-tabs .tab {\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  transition: all 0.2s;\n}\n\n.balance-tabs .tab:hover {\n  color: var(--text-primary);\n}\n\n.balance-tabs .tab.active {\n  background: var(--accent-primary);\n  color: white;\n}\n\n.crypto-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n}\n\n.crypto-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n}\n\n.crypto-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.crypto-card .crypto-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.crypto-card .crypto-icon.btc {\n  background: linear-gradient(145deg, #f7931a, #c77700);\n}\n\n.crypto-card .crypto-icon.eth {\n  background: linear-gradient(145deg, #627eea, #3c4fd1);\n}\n\n.crypto-card .crypto-icon.usdt {\n  background: linear-gradient(145deg, #26a17b, #1a7a5c);\n}\n\n.crypto-card .crypto-icon.usdc {\n  background: linear-gradient(145deg, #2775ca, #1a5ba3);\n}\n\n.crypto-card .crypto-icon.sol {\n  background: linear-gradient(145deg, #9945ff, #14f195);\n}\n\n.crypto-card .crypto-icon.bnb {\n  background: linear-gradient(145deg, #f3ba2f, #c99a00);\n}\n\n.crypto-info {\n  flex: 1;\n}\n\n.crypto-card .crypto-name {\n  display: block;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.crypto-symbol {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.crypto-price {\n  text-align: right;\n}\n\n.crypto-price .price {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.crypto-price .change {\n  font-size: 12px;\n}\n\n.crypto-price .change.positive {\n  color: var(--success);\n}\n\n.crypto-price .change.negative {\n  color: var(--danger);\n}\n\n.crypto-balance {\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.balance-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 0;\n}\n\n.balance-row .label {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.balance-row .value {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.balance-row .value.usd {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.crypto-address {\n  margin-bottom: 16px;\n}\n\n.address-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.address-header span {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.toggle-btn {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 4px;\n}\n\n.address-content {\n  display: flex;\n  gap: 8px;\n}\n\n.address-input {\n  flex: 1;\n  padding: 10px 12px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  font-family: monospace;\n  color: var(--text-primary);\n}\n\n.copy-btn,\n.qr-btn {\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  color: var(--text-muted);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.copy-btn:hover,\n.qr-btn:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.crypto-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.crypto-actions .action-btn {\n  flex: 1;\n  justify-content: center;\n  padding: 12px;\n  font-weight: 500;\n}\n\n.crypto-actions .action-btn.deposit {\n  background: var(--success);\n  border-color: var(--success);\n  color: white;\n}\n\n.crypto-actions .action-btn.withdraw {\n  background: var(--bg-primary);\n  border-color: var(--border-color);\n  color: var(--text-primary);\n}\n\n.test-notice {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: rgba(139, 92, 246, 0.1);\n  border: 1px solid rgba(139, 92, 246, 0.2);\n  border-radius: var(--radius-md);\n  color: var(--accent-primary);\n  font-size: 14px;\n}\n\n/* ============================================\n   PAYMENT LINKS PAGE STYLES\n   ============================================ */\n\n.payment-links-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.link-name-cell {\n  display: flex;\n  flex-direction: column;\n}\n\n.link-name {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.link-id {\n  font-size: 12px;\n  color: var(--text-muted);\n  font-family: monospace;\n}\n\n/* ============================================\n   TRANSACTIONS PAGE STYLES\n   ============================================ */\n\n.transactions-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.transaction-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.tx-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n}\n\n.tx-icon.incoming {\n  color: var(--success);\n}\n\n.tx-icon.outgoing {\n  color: var(--danger);\n}\n\n.tx-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.tx-id {\n  font-size: 13px;\n  font-family: monospace;\n  color: var(--text-primary);\n}\n\n.tx-description {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.amount-cell {\n  display: flex;\n  flex-direction: column;\n}\n\n.amount-cell .amount {\n  font-weight: 600;\n}\n\n.amount-cell .amount.incoming {\n  color: var(--success);\n}\n\n.amount-cell .amount.outgoing {\n  color: var(--danger);\n}\n\n.amount-cell .crypto-amount {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n/* Transaction Detail Modal */\n.transaction-detail-modal .detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.transaction-detail-modal .detail-row:last-child {\n  border-bottom: none;\n}\n\n.transaction-detail-modal .label {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.transaction-detail-modal .value {\n  font-size: 14px;\n  color: var(--text-primary);\n  text-align: right;\n  word-break: break-all;\n  max-width: 60%;\n}\n\n.transaction-detail-modal .value.hash {\n  font-family: monospace;\n  font-size: 12px;\n}\n\n/* Transactions Tabs */\n.transactions-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 1px solid var(--border-color);\n  margin-bottom: 0;\n}\n\n.transactions-tabs .tab-btn {\n  padding: 12px 20px;\n  background: none;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.transactions-tabs .tab-btn:hover {\n  color: var(--text-primary);\n}\n\n.transactions-tabs .tab-btn.active {\n  color: var(--text-primary);\n  border-bottom-color: var(--accent-primary);\n}\n\n/* Status Filter Tabs */\n.status-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 16px 0;\n  flex-wrap: wrap;\n}\n\n.status-tab {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 12px 16px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  cursor: pointer;\n  min-width: 100px;\n  transition: all 0.2s ease;\n}\n\n.status-tab:hover {\n  border-color: var(--accent-primary);\n}\n\n.status-tab.active {\n  border-color: var(--accent-primary);\n  background: rgba(99, 102, 241, 0.05);\n}\n\n.status-tab .tab-label {\n  font-size: 12px;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n}\n\n.status-tab .tab-count {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Table Toolbar */\n.table-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.search-box {\n  position: relative;\n  flex: 1;\n  max-width: 300px;\n}\n\n.search-box .search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n}\n\n.search-box input {\n  width: 100%;\n  padding: 10px 12px 10px 40px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 14px;\n  font-family: var(--iv-sans);\n}\n\n.search-box input::placeholder {\n  color: var(--text-muted);\n}\n\n.toolbar-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 14px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  color: var(--text-secondary);\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: var(--iv-sans);\n}\n\n.btn-toolbar:hover {\n  border-color: var(--text-muted);\n  color: var(--text-primary);\n}\n\n.dropdown-container {\n  position: relative;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  min-width: 180px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  padding: 0.25rem 0;\n}\n\n.dropdown-header {\n  padding: 10px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 10px 14px;\n  background: none;\n  border: none;\n  text-align: left;\n  font-size: 14px;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.dropdown-item:hover {\n  background: var(--bg-secondary);\n}\n\n.dropdown-item.active {\n  background: rgba(99, 102, 241, 0.1);\n  color: var(--accent-primary);\n}\n\n.dropdown-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  font-size: 14px;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.dropdown-checkbox:hover {\n  background: var(--bg-secondary);\n}\n\n.dropdown-checkbox input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--accent-primary);\n}\n\n/* Transactions Table */\n.transactions-table-container {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n}\n\n.transactions-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.transactions-table thead {\n  background: var(--bg-secondary);\n}\n\n.transactions-table th {\n  padding: 12px 16px;\n  text-align: left;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.transactions-table th.sortable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.transactions-table th.sortable:hover {\n  color: var(--text-primary);\n}\n\n.transactions-table th svg {\n  margin-left: 4px;\n  vertical-align: middle;\n  transition: transform 0.2s ease;\n}\n\n.transactions-table th svg.rotate-180 {\n  transform: rotate(180deg);\n}\n\n.transactions-table tbody tr {\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.transactions-table tbody tr:hover {\n  background: var(--bg-secondary);\n}\n\n.transactions-table td {\n  padding: 14px 16px;\n  font-size: 14px;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.transactions-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.amount-cell .amount-primary {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.amount-cell .amount-secondary {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n.customer-info .customer-name {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.customer-info .customer-email {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n.description-text {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n}\n\n.date-cell {\n  white-space: nowrap;\n}\n\n/* Merchant column for Super Admin */\n.merchant-cell {\n  min-width: 150px;\n}\n\n.merchant-cell .merchant-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.merchant-cell .merchant-name {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.merchant-cell .merchant-email {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.status-badge.status-created {\n  background: rgba(99, 102, 241, 0.1);\n  color: #6366f1;\n}\n\n.status-badge.status-pending {\n  background: rgba(245, 158, 11, 0.1);\n  color: #f59e0b;\n}\n\n.status-badge.status-processing {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n}\n\n.status-badge.status-succeeded {\n  background: rgba(34, 197, 94, 0.1);\n  color: #22c55e;\n}\n\n.status-badge.status-failed {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.status-badge.status-refunded {\n  background: rgba(168, 85, 247, 0.1);\n  color: #a855f7;\n}\n\n.status-badge.status-disputed {\n  background: rgba(249, 115, 22, 0.1);\n  color: #f97316;\n}\n\n.status-badge.status-uncaptured {\n  background: rgba(107, 114, 128, 0.1);\n  color: #6b7280;\n}\n\n.status-badge.status-not-supported {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n/* Pagination */\n.pagination-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.pagination-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.page-size-select {\n  padding: 6px 10px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 13px;\n  cursor: pointer;\n  font-family: var(--iv-sans);\n}\n\n/* Note: Pagination styles are defined in the Data Table section above */\n\n/* Empty State */\n.empty-state {\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.empty-state p {\n  font-size: 16px;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.empty-state span {\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n/* Loading Container */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n}\n\n.loading-container p {\n  margin-top: 16px;\n  color: var(--text-muted);\n}\n\n/* ============================================\n   PAYMENT LINK DETAIL PAGE STYLES\n   ============================================ */\n\n.payment-link-detail-page {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 14px;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.back-btn:hover {\n  color: var(--accent-primary);\n}\n\n.detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.detail-header-left {\n  flex: 1;\n}\n\n.detail-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  letter-spacing: 0.5px;\n}\n\n.detail-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 8px 0 4px;\n}\n\n.detail-title .detail-amount {\n  font-weight: 400;\n  color: var(--text-secondary);\n}\n\n.detail-subtitle {\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.detail-header-right {\n  display: flex;\n  align-items: center;\n}\n\n.status-badge-large {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.status-badge-large.active {\n  background: rgba(34, 197, 94, 0.1);\n  color: #22c55e;\n}\n\n.status-badge-large.inactive {\n  background: rgba(107, 114, 128, 0.1);\n  color: #6b7280;\n}\n\n/* URL Copy Box */\n.url-copy-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n}\n\n.url-copy-box input {\n  flex: 1;\n  padding: 10px 14px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  font-family: monospace;\n  font-size: 13px;\n  color: var(--text-primary);\n}\n\n.url-copy-box input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n}\n\n.btn-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-icon:hover {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n/* Detail Content Layout */\n.detail-content {\n  display: grid;\n  grid-template-columns: 1fr 380px;\n  gap: 24px;\n}\n\n.detail-content.full-width {\n  grid-template-columns: 1fr;\n}\n\n@media (max-width: 1024px) {\n  .detail-content {\n    grid-template-columns: 1fr;\n  }\n  .invoices-table-card {\n    overflow: scroll;\n  }\n  .table-wrapper {\n    overflow: scroll;\n  }\n}\n\n.detail-main {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Detail Section */\n.detail-section {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  /* margin-bottom: 16px; */\n}\n\n.detail-grid {\n  display: flex;\n  flex-direction: column;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.detail-row:last-child {\n  border-bottom: none;\n}\n\n.detail-key {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.detail-value {\n  font-size: 14px;\n  color: var(--text-primary);\n  text-align: right;\n}\n\n/* Status Badge */\n.status-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-badge.active {\n  background: rgba(34, 197, 94, 0.1);\n  color: #22c55e;\n}\n\n.status-badge.inactive {\n  background: rgba(107, 114, 128, 0.1);\n  color: #6b7280;\n}\n\n/* Empty Payments */\n.empty-payments {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.empty-payments .empty-icon {\n  color: var(--text-muted);\n  margin-bottom: 12px;\n}\n\n.empty-payments p {\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.empty-payments span {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n/* Events List */\n.events-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.event-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.event-item:last-child {\n  border-bottom: none;\n}\n\n.event-type {\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.event-date {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n/* Detail Sidebar */\n.detail-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.preview-section {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.preview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.preview-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.preview-device-toggle {\n  display: flex;\n  gap: 4px;\n}\n\n.device-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.device-btn:hover {\n  border-color: var(--text-secondary);\n  color: var(--text-secondary);\n}\n\n.device-btn.active {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n  color: white;\n}\n\n/* Browser Preview */\n.browser-preview {\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.browser-preview.mobile {\n  max-width: 280px;\n  margin: 0 auto 16px;\n}\n\n.browser-chrome {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.browser-dots {\n  display: flex;\n  gap: 6px;\n}\n\n.browser-dots .dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.browser-dots .dot.red {\n  background: #ef4444;\n}\n\n.browser-dots .dot.yellow {\n  background: #f59e0b;\n}\n\n.browser-dots .dot.green {\n  background: #22c55e;\n}\n\n.browser-url {\n  flex: 1;\n  padding: 4px 10px;\n  background: var(--bg-primary);\n  border-radius: 4px;\n  font-size: 11px;\n  color: var(--text-muted);\n  text-align: center;\n}\n\n.browser-content {\n  padding: 20px;\n  background: #f8f9fa;\n  min-height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Preview Card */\n.preview-card {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  width: 100%;\n  max-width: 320px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.preview-logo {\n  width: 40px;\n  height: 40px;\n  background: var(--accent-primary);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 700;\n  font-size: 18px;\n  margin: 0 auto 12px;\n}\n\n.preview-mode-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  background: rgba(249, 115, 22, 0.1);\n  color: #f97316;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.preview-name {\n  font-size: 13px;\n  color: #6b7280;\n  margin-bottom: 4px;\n}\n\n.preview-amount {\n  font-size: 28px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 16px;\n}\n\n.preview-details {\n  margin-bottom: 16px;\n}\n\n.preview-detail-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  font-size: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.preview-detail-row:last-child {\n  border-bottom: none;\n}\n\n.preview-detail-row span:first-child {\n  color: #6b7280;\n}\n\n.preview-detail-row span:last-child {\n  color: #111827;\n  font-weight: 500;\n}\n\n.preview-pay-btn {\n  width: 100%;\n  padding: 12px;\n  background: var(--accent-primary);\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 12px;\n}\n\n.preview-powered {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* Preview Actions */\n.preview-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.btn-full {\n  width: 100%;\n  justify-content: center;\n}\n\n.btn-danger-text {\n  background: none;\n  border: none;\n  color: #ef4444;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 10px;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.btn-danger-text:hover {\n  color: #dc2626;\n}\n\n/* ============================================\n   PAYMENT LINK DETAIL - TWO COLUMN LAYOUT\n   ============================================ */\n\n/* URL Copy Section */\n.url-copy-section {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n}\n\n.url-copy-section .url-input {\n  flex: 1;\n  padding: 10px 14px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  font-family: monospace;\n  font-size: 13px;\n  color: var(--text-primary);\n}\n\n.url-copy-section .url-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n}\n\n/* Two Column Layout */\n.detail-content-two-column {\n  display: grid;\n  grid-template-columns: 1fr 380px;\n  gap: 24px;\n}\n\n@media (max-width: 1024px) {\n  .detail-content-two-column {\n    grid-template-columns: 1fr;\n  }\n}\n\n.detail-left-column {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.detail-right-column {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Amount Badge in Title */\n.amount-badge {\n  font-weight: 400;\n  color: var(--text-secondary);\n}\n\n/* Empty Payments Section */\n.empty-payments-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.empty-payments-section .empty-icon {\n  color: var(--text-muted);\n  margin-bottom: 12px;\n}\n\n.empty-payments-section .empty-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.empty-payments-section .empty-subtitle {\n  font-size: 13px;\n  color: var(--text-muted);\n  margin-bottom: 16px;\n}\n\n/* Event Item */\n.event-name {\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n/* Preview Section Enhancements */\n.preview-content {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.preview-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.preview-test-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  background: rgba(249, 115, 22, 0.1);\n  color: #f97316;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.preview-card-body {\n  text-align: center;\n}\n\n.preview-button {\n  width: 100%;\n  padding: 12px;\n  background: var(--accent-primary);\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.preview-device-icons {\n  display: flex;\n  gap: 4px;\n}\n\n.device-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.device-icon:hover {\n  border-color: var(--text-secondary);\n  color: var(--text-secondary);\n}\n\n.device-icon.active {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n  color: white;\n}\n\n/* Action Buttons Column */\n.action-buttons-column {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.full-width {\n  width: 100%;\n  justify-content: center;\n}\n\n.btn-text {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: none;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: var(--radius-md);\n  transition: all 0.2s ease;\n}\n\n.btn-text.danger {\n  color: #ef4444;\n}\n\n.btn-text.danger:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.btn-text.success {\n  color: #22c55e;\n}\n\n.btn-text.success:hover {\n  background: rgba(34, 197, 94, 0.1);\n}\n\n/* ============================================\n   INVOICES PAGE STYLES\n   ============================================ */\n\n.invoices-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.invoice-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.invoice-icon {\n  color: var(--text-muted);\n}\n\n.invoice-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.invoice-id {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.invoice-customer {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.email {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n/* Invoice Preview */\n.invoice-preview {\n  padding: 24px;\n}\n\n.invoice-header-info {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 32px;\n}\n\n.company-info h3 {\n  font-size: 24px;\n  color: var(--accent-primary);\n  margin-bottom: 4px;\n}\n\n.company-info p {\n  color: var(--text-muted);\n  font-size: 14px;\n}\n\n.invoice-meta p {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n}\n\n/* .bill-to {\n  margin-bottom: 32px;\n} */\n\n.bill-to h4 {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n}\n\n.bill-to p {\n  font-size: 14px;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.invoice-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 24px;\n}\n\n.invoice-table th {\n  text-align: left;\n  padding: 12px;\n  background: var(--bg-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  border: 1px solid var(--border-color);\n}\n\n.invoice-table td {\n  padding: 12px;\n  font-size: 14px;\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n}\n\n.invoice-table tfoot td {\n  background: var(--bg-secondary);\n}\n\n/* ============================================\n   DEVELOPER PAGE STYLES\n   ============================================ */\n\n.developer-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.developer-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 0px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  width: fit-content;\n}\n\n.developer-tabs .tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  transition: all 0.2s;\n  border-bottom: none !important;\n  font-family: var(--iv-sans);\n}\n\n.developer-tabs .tab:hover {\n  color: var(--text-primary);\n}\n\n.developer-tabs .tab.active {\n  background: var(--accent-primary);\n  color: white !important;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.25),\n    0 8px 20px rgba(109, 93, 246, 0.35);\n}\n\n.token-card-body .token-height {\n  min-height: 32px;\n}\n\n.mode-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.mode-indicator.test {\n  background: rgba(139, 92, 246, 0.1);\n  color: var(--accent-primary);\n}\n\n.mode-indicator.live {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--success);\n}\n\n.key-item {\n  padding: 20px 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.key-item:last-of-type {\n  border-bottom: none;\n}\n\n.key-info {\n  margin-bottom: 12px;\n}\n\n.key-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.key-description {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.key-value {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n}\n\n.key-value code {\n  flex: 1;\n  font-family: monospace;\n  font-size: 13px;\n  color: var(--text-primary);\n  word-break: break-all;\n}\n\n.key-actions {\n  margin-top: 20px;\n}\n\n.warning-box {\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  border-radius: var(--radius-md);\n  margin-top: 20px;\n}\n\n.warning-box svg {\n  color: #ffffff;;\n  flex-shrink: 0;\n}\n\n.warning-box strong {\n  display: block;\n  font-size: 14px;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.warning-box p {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n/* Pending Wallet Request Banner */\n.pending-request-banner {\n  display: flex;\n  gap: 16px;\n  padding: 20px;\n  background: rgba(59, 130, 246, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  border-radius: var(--radius-md);\n  margin-bottom: 20px;\n}\n\n.pending-request-icon {\n  flex-shrink: 0;\n  color: var(--primary);\n}\n\n.pending-request-content h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 8px 0;\n}\n\n.pending-request-content > p {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin: 0 0 16px 0;\n}\n\n.pending-request-details {\n  background: var(--bg-secondary);\n  border-radius: var(--radius-sm);\n  padding: 12px 16px;\n  margin-bottom: 16px;\n}\n\n.pending-request-details .detail-row {\n  display: flex;\n  gap: 12px;\n  padding: 6px 0;\n}\n\n.pending-request-details .detail-row:not(:last-child) {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.pending-request-details .detail-label {\n  font-size: 13px;\n  color: var(--text-muted);\n  min-width: 100px;\n}\n\n.pending-request-details .detail-value {\n  font-size: 13px;\n  color: var(--text-primary);\n  word-break: break-all;\n}\n\n.pending-request-details .detail-value.mono {\n  font-family: \"SF Mono\", \"Monaco\", \"Menlo\", monospace;\n  font-size: 12px;\n}\n\n.btn-cancel-request {\n  padding: 8px 16px;\n  background: transparent;\n  border: 1px solid var(--error);\n  color: var(--error);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-cancel-request:hover {\n  background: var(--error);\n  color: white;\n}\n\n.btn-cancel-request:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Info Box (for wallet change info) */\n.settings-section .info-box {\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  background: rgba(59, 130, 246, 0.08);\n  border: 1px solid rgba(59, 130, 246, 0.2);\n  border-radius: var(--radius-md);\n  margin-top: 20px;\n}\n\n.settings-section .info-box svg {\n  color: var(--primary);\n  flex-shrink: 0;\n}\n\n.settings-section .info-box strong {\n  display: block;\n  font-size: 14px;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.settings-section .info-box p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n/* Webhooks */\n.webhooks-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.webhook-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n}\n\n.webhook-info {\n  flex: 1;\n}\n\n.webhook-url {\n  display: block;\n  font-size: 14px;\n  font-family: monospace;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.webhook-events {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.event-tag {\n  padding: 4px 8px;\n  background: var(--bg-primary);\n  border-radius: 4px;\n  font-size: 11px;\n  font-family: monospace;\n  color: var(--text-secondary);\n}\n\n.webhook-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.webhook-date {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.webhook-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.events-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 12px;\n}\n\n.event-item {\n  padding: 12px;\n  background: var(--bg-secondary);\n  border-radius: var(--radius-sm);\n}\n\n.event-item code {\n  display: block;\n  font-size: 13px;\n  color: var(--accent-primary);\n  margin-bottom: 4px;\n}\n\n.event-item span {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n/* Quickstart */\n.steps {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.step {\n  display: flex;\n  gap: 20px;\n}\n\n.step-number {\n  width: 32px;\n  height: 32px;\n  background: var(--accent-primary);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.step-content {\n  flex: 1;\n}\n\n.step-content h4 {\n  font-size: 16px;\n  color: var(--text-primary);\n  margin-bottom: 12px;\n}\n\n.step-content p {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.code-block {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n  font-family: monospace;\n}\n\n.code-block code {\n  flex: 1;\n  font-size: 13px;\n  color: var(--text-primary);\n}\n\n.code-block.large {\n  display: block;\n  position: relative;\n}\n\n.code-block.large pre {\n  white-space: pre-wrap;\n  font-size: 13px;\n  color: var(--text-primary);\n  line-height: 1.6;\n}\n\n.code-block.large .icon-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n\n.language-tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 12px;\n}\n\n.language-tabs button {\n  padding: 6px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.language-tabs button:hover {\n  border-color: var(--text-muted);\n}\n\n.language-tabs button.active {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n  color: white;\n}\n\n.resources-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  margin-top: 24px;\n}\n\n.resource-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 24px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  text-decoration: none;\n  transition: all 0.2s;\n}\n\n.resource-card:hover {\n  border-color: var(--accent-primary);\n  box-shadow: var(--shadow-md);\n}\n\n.resource-card svg {\n  color: var(--accent-primary);\n  margin-bottom: 12px;\n}\n\n.resource-card h4 {\n  font-size: 16px;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.resource-card p {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n/* ============================================\n   SETTINGS PAGE STYLES\n   ============================================ */\n\n.settings-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.settings-container {\n  display: flex;\n  gap: 24px;\n}\n\n.settings-sidebar {\n  width: 240px;\n  flex-shrink: 0;\n}\n\n.settings-tab {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: var(--radius-md);\n  transition: all 0.2s;\n  text-align: left;\n}\n\n.settings-tab:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.settings-tab.active {\n  background: rgba(139, 92, 246, 0.1);\n  color: var(--accent-primary);\n}\n\n.settings-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.settings-section {\n  margin-bottom: 24px;\n}\n\n.section-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.section-header svg {\n  color: var(--accent-primary);\n  flex-shrink: 0;\n}\n\n.section-header h2 {\n  font-size: 20px;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.section-header p {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.form-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n}\n\n.form-card .form-group {\n  margin-bottom: 20px;\n}\n\n.form-card .form-group:last-child {\n  margin-bottom: 0;\n}\n\n.form-card .form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.form-card .form-group input,\n.form-card .form-group select,\n.form-card .form-group textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.form-card .form-group input:focus,\n.form-card .form-group select:focus,\n.form-card .form-group textarea:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  background: var(--bg-primary);\n}\n\n.form-card .form-row {\n  display: flex;\n  gap: 16px;\n}\n\n.form-card .form-row .form-group {\n  flex: 1;\n}\n\n.form-card h3 {\n  font-size: 16px;\n  color: var(--text-primary);\n  margin-bottom: 16px;\n}\n\n.logo-upload {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.logo-preview {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(\n    135deg,\n    var(--accent-primary),\n    var(--accent-secondary)\n  );\n  border-radius: var(--radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.hint {\n  font-size: 12px;\n  color: var(--text-muted);\n  display: block;\n  margin-top: 4px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--accent-primary);\n}\n\n/* Toggle Switch */\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-switch .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--bg-tertiary);\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.toggle-switch .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\n.toggle-switch input:checked + .slider {\n  background-color: var(--accent-primary);\n}\n\n.toggle-switch input:checked + .slider:before {\n  transform: translateX(20px);\n}\n\n.security-item,\n.notification-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n}\n\n.security-info,\n.notification-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.security-info svg,\n.notification-info svg {\n  color: var(--text-muted);\n}\n\n.security-label,\n.notification-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.security-description,\n.notification-description {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.settings-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 24px;\n  border-top: 1px solid var(--border-color);\n}\n\n.change-password-btn {\n  width: auto !important;\n}\n\n/* Password Input Wrapper */\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  padding-right: 40px;\n  width: 100%;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 10px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n  transition: color 0.2s;\n}\n\n.password-toggle:hover {\n  color: var(--text-primary);\n  background: transparent;\n}\n\n/* Message Banner */\n.message-banner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: var(--radius-md);\n  margin-bottom: 16px;\n}\n\n.message-banner.success {\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  color: #10b981;\n}\n\n.message-banner.error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #ef4444;\n}\n\n.message-banner.info {\n  background: rgba(59, 130, 246, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  color: #3b82f6;\n}\n\n.message-banner span {\n  flex: 1;\n  font-size: 14px;\n}\n\n.message-banner .close-btn {\n  width: 24px;\n  height: 24px;\n  font-size: 18px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.message-banner .close-btn:hover {\n  opacity: 1;\n  background: transparent;\n}\n\n/* Error Text */\n.error-text {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #ef4444;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n/* Input Error State */\n.input-error {\n  border-color: #ef4444 !important;\n}\n\n.input-error:focus {\n  border-color: #ef4444 !important;\n  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);\n}\n\n/* Input Disabled State */\n.input-disabled {\n  background-color: var(--bg-tertiary) !important;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* Loading Container */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  gap: 16px;\n}\n\n.loading-container p {\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n/* ============================================\n   MODAL STYLES\n   ============================================ */\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal {\n  background: var(--bg-primary);\n  border-radius: var(--radius-lg);\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.modal.large {\n  max-width: 700px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-color);\n}\n.modal-header.title-cancel {\n    justify-content: left;\n}\n.modal-header h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.close-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-sm);\n}\n\n.close-btn:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n.modal-body .form-group {\n  margin-bottom: 20px;\n}\n\n.modal-body .form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.modal-body .form-group input,\n.modal-body .form-group select,\n.modal-body .form-group textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 14px;\n  font-family: var(--iv-sans);\n}\n\n.input-with-addon {\n  display: flex;\n  align-items: center;\n}\n\n.input-with-addon .addon {\n  padding: 12px 16px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-right: none;\n  border-radius: var(--radius-md) 0 0 var(--radius-md);\n  color: var(--text-muted);\n}\n\n.input-with-addon input {\n  flex: 1;\n  border-radius: 0;\n}\n\n.input-with-addon select {\n  width: 100px;\n  border-radius: 0 var(--radius-md) var(--radius-md) 0;\n  border-left: none;\n}\n\n.input-with-addon .addon-right {\n  padding: 12px 16px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-left: none;\n  border-radius: 0 var(--radius-md) var(--radius-md) 0;\n  color: var(--text-muted);\n  font-weight: 500;\n  min-width: 60px;\n  text-align: center;\n}\n\n.input-with-addon input:only-child,\n.input-with-addon input:first-child:not(:last-child) {\n  border-radius: var(--radius-md) 0 0 var(--radius-md);\n}\n\n.crypto-checkboxes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid var(--border-color);\n}\n\n/* Confirmation Modal */\n.confirm-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: var(--bg-primary);\n  border-radius: var(--radius-lg);\n  padding: 32px;\n  max-width: 400px;\n  width: 90%;\n  z-index: 1001;\n  text-align: center;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.confirm-modal-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n}\n\n.confirm-modal-icon.danger {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.confirm-modal-icon.warning {\n  background: rgba(245, 158, 11, 0.1);\n  color: #f59e0b;\n}\n\n.confirm-modal h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 12px;\n}\n\n.confirm-modal p {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin-bottom: 24px;\n  line-height: 1.5;\n}\n\n.confirm-modal p strong {\n  color: var(--text-primary);\n}\n\n.confirm-modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.confirm-modal-actions button {\n  flex: 1;\n  padding: 12px 20px;\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-danger {\n  background: #ef4444;\n  color: white;\n  border: none;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #dc2626;\n}\n\n.btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Invoice Items */\n.invoice-items {\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.item-row {\n  display: grid;\n  grid-template-columns: 1fr 80px 100px 100px 40px;\n  gap: 8px;\n  padding: 12px;\n  align-items: center;\n}\n\n.item-row.header {\n  background: var(--bg-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.item-row input {\n  padding: 8px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n}\n\n.item-total {\n  font-size: 14px;\n  color: var(--text-primary);\n  text-align: right;\n}\n\n.remove-btn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 18px;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n}\n\n.remove-btn:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger);\n}\n\n.add-item-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: none;\n  border: none;\n  color: var(--accent-primary);\n  font-size: 14px;\n  cursor: pointer;\n  font-family: var(--iv-sans);\n}\n\n.add-item-btn:hover {\n  text-decoration: underline;\n}\n\n.invoice-summary {\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n  padding: 16px;\n  margin-top: 20px;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.summary-row.total {\n  border-top: 1px solid var(--border-color);\n  padding-top: 16px;\n  margin-top: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* ============================================\n   RESPONSIVE STYLES\n   ============================================ */\n\n@media (max-width: 1280px) {\n  .dashboard-layout {\n    display: unset;\n  }\n  .transactions-table-container {\n    overflow: scroll;\n  }\n}\n\n@media (max-width: 1200px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .dashboard-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .resources-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 992px) {\n  .sidebar {\n    width: var(--sidebar-collapsed-width);\n  }\n\n  .sidebar .logo-text,\n  .sidebar .nav-item span,\n  .sidebar .version-info {\n    display: none;\n  }\n\n  .sidebar .logo {\n    justify-content: center;\n  }\n\n  .sidebar .nav-item {\n    justify-content: center;\n    padding: 12px;\n  }\n\n  .main-content {\n    margin-left: var(--sidebar-collapsed-width);\n  }\n\n  .settings-container {\n    flex-direction: column;\n  }\n\n  .settings-sidebar {\n    width: 100%;\n    display: unset;\n    gap: 8px;\n    overflow-x: auto;\n    padding-bottom: 8px;\n  }\n\n  .settings-tab {\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n  .logo img.desktop_lg {\n    display: none;\n  }\n  .logo img.mobile_xl {\n    display: block;\n    padding-right: 8px;\n    max-width: 40px;\n  }\n  .hide-logoBtn {\n    display: none;\n  }\n  .sidebar-header {\n    padding-bottom: 12px;\n  }\n  .sidebar-collapsed .collapse-btn  {\n    margin-left: 0px;\n  }\n  .sidebar-header {\n    justify-content: center;\n  }\n  .logo-icon img {\n    margin-left: 0px;\n    margin-top: 0px;\n  }\n  .token-card-body .token-height {\n    min-height: 0px;\n  }\n  .sidebar-footer {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .page-header {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .stats-row {\n    flex-wrap: wrap;\n  }\n\n  .stat-item {\n    flex: 1 1 calc(50% - 8px);\n  }\n\n  .crypto-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .table-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .controls-left,\n  .controls-right {\n    flex-wrap: wrap;\n  }\n\n  .search-box input {\n    width: 100%;\n  }\n\n  .header-right {\n    gap: 8px;\n  }\n\n  .profile-info {\n    display: none;\n  }\n\n  .resources-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-card .form-row {\n    flex-direction: column;\n  }\n  .transactions-table-container {\n    overflow: scroll;\n  }\n  .guide-nav-item span {\n    display: block !important;\n  }\n}\n\n@media (max-width: 576px) {\n  /* .payment-amount{overflow-x:scroll;} */\n  .sidebar {\n    display: none;\n  }\n\n  .main-content {\n    margin-left: 0;\n  }\n\n  .page-content {\n    padding: 16px;\n  }\n\n  .total-balance-card {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n\n  .total-balance-actions {\n    width: 100%;\n    flex-direction: column;\n  }\n  .invoice-meta span.status-badge.partially_paid {\n    font-size: 12px;\n  }\n  .brand img {\n    max-width: 140px !important;\n  }\n}\n\n/* React DatePicker Overrides */\n.react-datepicker-wrapper {\n  width: auto;\n  display: inline-flex;\n  align-items: center;\n}\n\n.react-datepicker__input-container {\n  display: flex;\n  align-items: center;\n}\n\n.react-datepicker__input-container input {\n  border: none;\n  background: transparent;\n  color: var(--text-primary) !important;\n  font-size: 14px;\n  width: 200px;\n  outline: none;\n}\n\n.react-datepicker {\n  font-family: inherit;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-lg);\n  background: var(--bg-primary);\n}\n\n.react-datepicker__header {\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.react-datepicker__current-month,\n.react-datepicker__day-name,\n.react-datepicker__day {\n  color: var(--text-primary);\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-range,\n.react-datepicker__day--in-selecting-range {\n  background: var(--accent-primary) !important;\n  color: #fff !important;\n}\n\n.react-datepicker__day:hover {\n  background: var(--bg-tertiary);\n}\n\n.react-datepicker__day--keyboard-selected {\n  background: var(--accent-primary);\n  color: #fff;\n}\n\n/* Date picker clear button - make it visible */\n.react-datepicker__close-icon {\n  position: relative;\n  right: 0;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n.react-datepicker__close-icon::after {\n  background-color: #ef4444 !important;\n  color: #fff !important;\n  content: \"×\" !important;\n  height: 20px !important;\n  width: 20px !important;\n  padding: 2px !important;\n  font-size: 20px !important;\n\n  line-height: 18px;\n  cursor: pointer;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.react-datepicker__close-icon:hover::after {\n  background-color: #dc2626 !important;\n}\n\n/* Ensure date picker input text is visible */\n.date-filter .react-datepicker__input-container input {\n  color: var(--text-primary) !important;\n  background: transparent !important;\n  font-family: var(--iv-sans);\n}\n\n.date-filter .react-datepicker__input-container input::placeholder {\n  color: var(--text-muted);\n}\n\n/* Date filter container adjustments */\n.date-filter .react-datepicker-wrapper {\n  flex: 1;\n}\n\n/* ============================================\n   Advanced Filter Toolbar Styles\n   ============================================ */\n\n/* Search clear button */\n.search-clear {\n  position: absolute;\n  right: 2px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.search-clear:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.search-box {\n  position: relative;\n}\n\n/* Filter dropdown improvements */\n.filter-dropdown {\n  min-width: 280px;\n  max-height: 400px;\n  overflow-y: auto;\n  left: 0;\n  right: auto;\n}\n\n.dropdown-section {\n  padding: 8px 0;\n}\n\n.dropdown-divider {\n  height: 1px;\n  background: var(--border-color);\n  margin: 4px 0;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  width: 100%;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--text-secondary);\n  transition: all 0.2s;\n}\n\n.dropdown-item:hover {\n  background: var(--bg-tertiary);\n}\n\n.dropdown-item.active {\n  color: var(--accent-primary);\n  background: rgba(124, 58, 237, 0.08);\n}\n\n.dropdown-count {\n  margin-left: auto;\n  font-size: 12px;\n  color: var(--text-secondary);\n  background: var(--bg-tertiary);\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n/* Advanced filter button with badge */\n.btn-toolbar.has-filters {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n  background: rgba(124, 58, 237, 0.08);\n}\n\n.filter-count-badge {\n  background: var(--accent-primary);\n  color: white;\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 10px;\n  margin-left: 4px;\n}\n\n/* Column dropdown improvements */\n.column-dropdown {\n  min-width: 220px;\n}\n\n.dropdown-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.reset-columns-btn {\n  background: none;\n  border: none;\n  color: var(--accent-primary);\n  cursor: pointer;\n  font-size: 12px;\n  text-transform: none;\n  letter-spacing: 0;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.reset-columns-btn:hover {\n  background: rgba(124, 58, 237, 0.1);\n}\n\n.dropdown-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.dropdown-checkbox:hover {\n  background: var(--bg-tertiary);\n}\n\n.dropdown-checkbox input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkbox-custom {\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--border-color);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.dropdown-checkbox input[type=\"checkbox\"]:checked + .checkbox-custom {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n  color: white;\n}\n\n/* Always-on columns: checked, not clickable, visibly inert. */\n.dropdown-checkbox.is-locked {\n  cursor: not-allowed;\n  color: var(--text-secondary);\n}\n\n.dropdown-checkbox.is-locked:hover {\n  background: transparent;\n}\n\n.dropdown-checkbox.is-locked .checkbox-custom {\n  opacity: 0.55;\n}\n\n/* Clear all filters button */\n.btn-clear-filters {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 12px;\n  background: transparent;\n  border: 1px solid var(--error-color);\n  color: var(--text-secondary);\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-clear-filters:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n/* Column toggle container for DataTable */\n.column-toggle-container {\n  position: relative;\n}\n\n.column-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  color: var(--text-secondary);\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.column-toggle-btn:hover,\n.column-toggle-btn.active {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.column-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  box-shadow: var(--shadow-lg);\n  z-index: 100;\n  min-width: 220px;\n}\n\n.column-dropdown-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.column-dropdown-list {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.column-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: background 0.2s;\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.column-checkbox:hover {\n  background: var(--bg-tertiary);\n}\n\n.column-checkbox input[type=\"checkbox\"] {\n  display: none;\n}\n\n/* Clear filters button in DataTable */\n.clear-filters-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 12px;\n  background: transparent;\n  border: none;\n  color: var(--accent-primary);\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.clear-filters-btn:hover {\n  text-decoration: underline;\n}\n\n/* ===========================================\n   Payment Page Styles\n   =========================================== */\n\n.payment-page {\n  min-height: 100vh;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.payment-container {\n  width: 100%;\n  max-width: 420px;\n}\n\n.payment-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n.payment-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 24px 32px;\n  gap: 12px;\n}\n.payment-space {\n  padding: 1rem;\n}\n.payment-logo {\n  width: 56px;\n  height: 56px;\n  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 700;\n  color: white;\n}\n\n.payment-test-badge {\n  background: #fef3c7;\n  color: #d97706;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 12px;\n  letter-spacing: 0.5px;\n}\n\n.payment-details {\n  text-align: center;\n  padding: 0 24px 24px;\n}\n\n.payment-name {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0 0 8px;\n}\n\n.payment-amount {\n  font-size: 48px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 8px;\n}\n\n.payment-currency {\n  font-size: 16px;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.payment-description {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 12px 0 0;\n  line-height: 1.5;\n}\n\n.payment-timer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px;\n  background: #fef3c7;\n  color: #d97706;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.payment-info {\n  padding: 16px 24px;\n  background: #f9fafb;\n  border-top: 1px solid #e5e7eb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.payment-info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n}\n\n.payment-info-row:not(:last-child) {\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.info-label {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.info-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.payment-address {\n  padding: 16px 24px;\n}\n\n.payment-address label {\n  display: block;\n  font-size: 12px;\n  color: #6b7280;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.address-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  background: #f3f4f6;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.address-text {\n  flex: 1;\n  font-size: 12px;\n  font-family: monospace;\n  color: #374151;\n  word-break: break-all;\n  color:#fff;\n}\n\n.copy-btn {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.copy-btn:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.payment-buttons {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.payment-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 16px 24px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.wallet-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.wallet-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n}\n\n.qr-btn {\n  background: white;\n  color: #667eea;\n  border: 2px solid #667eea;\n}\n\n.qr-btn:hover {\n  background: #f5f3ff;\n}\n\n.payment-footer {\n  padding: 16px 24px;\n  text-align: center;\n  border-top: 1px solid #e5e7eb;\n}\n\n.payment-footer p {\n  font-size: 12px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.payment-footer strong {\n  color: #6b7280;\n}\n.pc-powered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin: 0;\n  font-size: 0.82rem;\n  color: #9ca3af;\n}\n.pc-powered img {\n  height: 18px;\n  width: auto;\n  margin-top: 1px;\n}\n/* Payment Status States */\n.payment-loading,\n.payment-error,\n.payment-success,\n.payment-expired,\n.payment-inactive {\n  padding: 60px 24px;\n  text-align: center;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.payment-loading .loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.payment-loading p,\n.payment-error p,\n.payment-success p,\n.payment-expired p,\n.payment-inactive p {\n  color: #6b7280;\n  margin: 8px 0 0;\n}\n\n.error-icon {\n  color: #ef4444;\n  margin-bottom: 16px;\n}\n\n.success-icon {\n  color: #10b981;\n  margin-bottom: 16px;\n}\n\n.expired-icon {\n  color: #f59e0b;\n  margin-bottom: 16px;\n}\n\n.inactive-icon {\n  color: #6b7280;\n  margin-bottom: 16px;\n}\n\n.payment-error h2,\n.payment-success h2,\n.payment-expired h2,\n.payment-inactive h2 {\n  font-size: 20px;\n  color: #111827;\n  margin: 0 0 8px;\n}\n\n.paid-date,\n.expired-hint {\n  font-size: 13px;\n  color: #9ca3af;\n  margin-top: 8px;\n}\n\n/* QR Modal */\n.qr-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.qr-modal {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  max-width: 360px;\n  width: 100%;\n  text-align: center;\n}\n\n.qr-modal h3 {\n  font-size: 20px;\n  color: #111827;\n  margin: 0 0 8px;\n}\n\n.qr-hint {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0 0 24px;\n}\n\n.qr-code-container {\n  background: white;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  display: inline-block;\n  margin-bottom: 16px;\n}\n\n.qr-code-container img {\n  display: block;\n  width: 250px;\n  height: 250px;\n}\n\n.qr-amount {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n\n.qr-amount strong {\n  font-size: 24px;\n  color: #111827;\n}\n\n.qr-amount span {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.qr-close-btn {\n  width: 100%;\n  padding: 14px 24px;\n  background: #f3f4f6;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.qr-close-btn:hover {\n  background: #e5e7eb;\n}\n\n/* Status badge colors for paid, expired */\n.status-badge.paid,\n.status-badge-large.paid {\n  background: #d1fae5;\n  color: #059669;\n}\n\n.status-badge.expired,\n.status-badge-large.expired {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.status-badge.cancelled,\n.status-badge-large.cancelled {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n/* ============================================\n   Drawer Styles\n   ============================================ */\n\n.drawer-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity 0.3s ease,\n    visibility 0.3s ease;\n}\n\n.drawer-overlay.open {\n  opacity: 1;\n  visibility: visible;\n}\n\n.drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 480px;\n  max-width: 100%;\n  height: 100vh;\n  background: var(--bg-primary);\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.3s ease;\n}\n\n.drawer.open {\n  transform: translateX(0);\n}\n\n.drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n}\n\n.drawer-header h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.drawer-close-btn {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  transition: all 0.2s;\n}\n\n.drawer-close-btn:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n.drawer-body .form-group {\n  margin-bottom: 20px;\n}\n\n.drawer-body .form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.drawer-body .form-group input[type=\"text\"],\n.drawer-body .form-group input[type=\"number\"],\n.drawer-body .form-group select,\n.drawer-body .form-group textarea {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 14px;\n  color: var(--text-primary);\n  background: var(--bg-primary);\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.drawer-body .form-group input:focus,\n.drawer-body .form-group select:focus,\n.drawer-body .form-group textarea:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);\n}\n\n.drawer-body .form-group input:disabled,\n.drawer-body .form-group select:disabled {\n  background: var(--bg-secondary);\n  color: var(--text-muted);\n  cursor: not-allowed;\n}\n\n.drawer-body .input-with-addon {\n  display: flex;\n  align-items: stretch;\n}\n\n.drawer-body .input-with-addon input {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: none;\n}\n\n.drawer-body .input-with-addon .addon-right {\n  display: flex;\n  align-items: center;\n  padding: 0 14px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-left: none;\n  border-radius: 0 8px 8px 0;\n  font-size: 14px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.drawer-body .checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  cursor: pointer;\n  font-weight: 400;\n}\n\n.drawer-body .checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--accent-primary);\n  cursor: pointer;\n}\n\n.drawer-body .checkbox-label span {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.drawer-footer {\n  display: flex;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n  flex-shrink: 0;\n}\n\n.drawer-footer .btn-secondary {\n  flex: 1;\n  padding: 12px 20px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.drawer-footer .btn-secondary:hover {\n  background: var(--bg-secondary);\n}\n\n.drawer-footer .btn-primary {\n  flex: 1;\n  padding: 12px 20px;\n  background: var(--accent-primary);\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.drawer-footer .btn-primary:hover:not(:disabled) {\n  background: var(--accent-secondary);\n}\n\n.drawer-footer .btn-primary:disabled {\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n  cursor: not-allowed;\n}\n\n/* Mobile responsiveness for drawer */\n@media (max-width: 520px) {\n  .drawer {\n    width: 100%;\n  }\n}\n\n/* =========================================\n   Payment Links - API Key & New UI Styles\n   ========================================= */\n\n/* API Key Cell */\n.api-key-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.api-key-value {\n  font-family: \"Monaco\", \"Menlo\", monospace;\n  font-size: 12px;\n  background: var(--bg-secondary);\n  padding: 4px 8px;\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.action-icon-btn.small {\n  padding: 4px;\n  width: 24px;\n  height: 24px;\n}\n\n/* Link URL Cell */\n.link-url-cell {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Link ID Small */\n.link-id-small {\n  font-family: \"Monaco\", \"Menlo\", monospace;\n  font-size: 11px;\n  color: var(--text-secondary);\n  background: var(--bg-secondary);\n  padding: 2px 6px;\n  border-radius: 4px;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Text Muted */\n.text-muted {\n  color: var(--text-muted);\n  font-size: 12px;\n  font-style: italic;\n}\n\n/* Link Description */\n.link-description {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 2px;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Address Cell */\n.address-cell {\n  font-family: \"Monaco\", \"Menlo\", monospace;\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n/* Info Cards Row */\n.info-cards-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.info-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 16px;\n}\n\n.info-card-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.info-card-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.info-card-content code {\n  flex: 1;\n  font-family: \"Monaco\", \"Menlo\", monospace;\n  font-size: 12px;\n  background: var(--bg-secondary);\n  padding: 8px 12px;\n  border-radius: var(--radius-sm);\n  color: var(--text-primary);\n  word-break: break-all;\n  overflow-x: auto;\n}\n\n.btn-icon.small {\n  padding: 6px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  color: var(--text-secondary);\n  transition: all 0.2s;\n}\n\n.btn-icon.small:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n/* Drawer Info Box */\n.drawer-info {\n  color: var(--text-secondary);\n  font-size: 14px;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.info-box {\n  background: rgba(139, 92, 246, 0.1);\n  border: 1px solid rgba(139, 92, 246, 0.2);\n  border-radius: var(--radius-md);\n  padding: 16px;\n  margin-top: 20px;\n}\n\n.info-box h4 {\n  color: var(--accent-primary);\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.info-box ol {\n  margin: 0;\n  padding-left: 20px;\n  color: var(--text-secondary);\n  font-size: 13px;\n  line-height: 1.8;\n}\n\n.info-box code {\n  font-family: \"Monaco\", \"Menlo\", monospace;\n  font-size: 11px;\n  background: rgba(139, 92, 246, 0.2);\n  padding: 2px 6px;\n  border-radius: 4px;\n  color: var(--accent-primary);\n}\n\n/* Form Hint */\n.form-hint {\n  display: block;\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 4px;\n}\n\n/* Header Actions */\n.header-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n/* Merchant Filter Dropdown */\n.merchant-filter {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 14px;\n  min-width: 180px;\n  cursor: pointer;\n  outline: none;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.merchant-filter:hover {\n  border-color: var(--primary-color);\n}\n\n.merchant-filter:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n/* Large Drawer */\n.drawer.drawer-large {\n  width: 680px;\n  max-width: 90vw;\n}\n\n/* Usage Guide Content */\n.usage-guide-content {\n  padding: 0 !important;\n}\n\n.guide-section {\n  padding: 24px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.guide-section:last-child {\n  border-bottom: none;\n}\n\n.guide-section-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.guide-section-header svg {\n  color: var(--accent-primary);\n}\n\n.guide-section-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n/* Quick Start Steps */\n.guide-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.guide-step {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.step-number {\n  width: 28px;\n  height: 28px;\n  background: var(--accent-primary);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.step-content h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 4px 0;\n}\n\n.step-content p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Code Block */\n.code-block {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.code-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.method {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.method.post {\n  background: #22c55e20;\n  color: #22c55e;\n}\n\n.method.get {\n  background: #3b82f620;\n  color: #3b82f6;\n}\n\n.endpoint {\n  font-family: \"Monaco\", \"Menlo\", monospace;\n  font-size: 13px;\n  color: var(--text-primary);\n  flex: 1;\n}\n\n.copy-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  color: var(--text-secondary);\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.copy-btn:hover {\n  background: var(--accent-primary);\n  color: white;\n  border-color: var(--accent-primary);\n}\n\n.code-description {\n  padding: 12px 16px;\n}\n\n.code-description p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n/* Parameters Section */\n.params-section {\n  margin-bottom: 20px;\n}\n\n.params-section h4 {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 12px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.param-item {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.param-item:last-child {\n  border-bottom: none;\n}\n\n.param-name {\n  font-family: \"Monaco\", \"Menlo\", monospace;\n  font-size: 12px;\n  background: var(--bg-tertiary);\n  padding: 4px 8px;\n  border-radius: 4px;\n  color: var(--accent-primary);\n}\n\n.param-required {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: #ef444420;\n  color: #ef4444;\n}\n\n.param-optional {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n}\n\n.param-desc {\n  width: 100%;\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin: 4px 0 0 0;\n}\n\n/* Response Example */\n.response-example {\n  background: #1e1e2e;\n  color: #cdd6f4;\n  padding: 16px;\n  border-radius: 8px;\n  font-family: \"Monaco\", \"Menlo\", monospace;\n  font-size: 12px;\n  line-height: 1.6;\n  overflow-x: auto;\n  margin: 0;\n}\n\n/* Code Examples */\n.code-example {\n  margin-bottom: 20px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.code-example:last-child {\n  margin-bottom: 0;\n}\n\n.code-example-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.lang-badge {\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.lang-badge.nodejs {\n  background: #22c55e20;\n  color: #22c55e;\n}\n\n.lang-badge.php {\n  background: #8b5cf620;\n  color: #8b5cf6;\n}\n\n.lang-badge.python {\n  background: #3b82f620;\n  color: #3b82f6;\n}\n\n.code-content {\n  background: #1e1e2e;\n  color: #cdd6f4;\n  padding: 16px;\n  font-family: \"Monaco\", \"Menlo\", monospace;\n  font-size: 11px;\n  line-height: 1.6;\n  overflow-x: auto;\n  margin: 0;\n  max-height: 400px;\n}\n\n/* Security Info */\n.security-info {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.security-item {\n  padding: 16px;\n  background: var(--bg-tertiary);\n  border-radius: 8px;\n}\n\n.security-item.warning {\n  background: #fef3c720;\n  border: 1px solid #fbbf2440;\n}\n\n.security-item h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 8px 0;\n}\n\n.security-item p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.security-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 12px;\n  font-size: 13px;\n}\n\n.security-table th,\n.security-table td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.security-table th {\n  background: var(--bg-secondary);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.security-table td {\n  color: var(--text-secondary);\n}\n\n.result {\n  font-weight: 500;\n}\n\n.result.success {\n  color: #22c55e;\n}\n\n.result.error {\n  color: #ef4444;\n}\n\n/* Flow Diagram */\n.flow-diagram {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 20px;\n  background: var(--bg-tertiary);\n  border-radius: 12px;\n  overflow-x: auto;\n}\n\n.flow-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  min-width: 80px;\n}\n\n.flow-icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  font-size: 24px;\n  margin-bottom: 8px;\n}\n\n.flow-icon.customer {\n  background: #3b82f620;\n}\n\n.flow-icon.server {\n  background: #8b5cf620;\n}\n\n.flow-icon.api {\n  background: #22c55e20;\n}\n\n.flow-icon.redirect {\n  background: #f59e0b20;\n}\n\n.flow-icon.payment {\n  background: #ec489920;\n}\n\n.flow-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.flow-desc {\n  font-size: 10px;\n  color: var(--text-muted);\n  line-height: 1.3;\n}\n\n.flow-arrow {\n  color: var(--text-muted);\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .drawer.drawer-large {\n    width: 100%;\n  }\n\n  .flow-diagram {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .flow-arrow {\n    display: none;\n  }\n}\n\n/* ============================================\n   Session Detail Drawer Styles\n   ============================================ */\n\n/* Session Status Banner */\n.session-status-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border: 1px solid #bae6fd;\n}\n\n.session-status-banner.paid {\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);\n  border-color: #86efac;\n}\n\n.session-status-banner.pending {\n  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);\n  border-color: #fcd34d;\n}\n\n.session-status-banner.expired,\n.session-status-banner.failed {\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border-color: #fca5a5;\n}\n\n.session-status-banner.processing {\n  background: linear-gradient(135deg, #f0f9ff 0%, #dbeafe 100%);\n  border-color: #93c5fd;\n}\n\n.session-amount-large {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* Drawer Sections */\n.drawer-section {\n  margin-bottom: 24px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.drawer-section:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.drawer-section-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Detail Grid */\n.detail-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.detail-key {\n  font-size: 13px;\n  color: var(--text-muted);\n  flex-shrink: 0;\n  min-width: 120px;\n}\n\n.detail-value {\n  font-size: 13px;\n  color: var(--text-primary);\n  text-align: right;\n  word-break: break-word;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.detail-value.mono {\n  font-family: \"JetBrains Mono\", \"Fira Code\", monospace;\n  font-size: 12px;\n}\n\n/* Session Transactions List */\n.session-transactions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.session-transaction-item {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  padding: 14px 16px;\n}\n\n.tx-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.tx-amount {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.tx-details {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.tx-detail-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.tx-label {\n  color: var(--text-muted);\n  min-width: 70px;\n}\n\n.tx-value {\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.tx-value.mono {\n  font-family: \"JetBrains Mono\", \"Fira Code\", monospace;\n}\n\n/* Empty Transactions */\n.empty-transactions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  background: var(--bg-secondary);\n  border-radius: 10px;\n  border: 1px dashed var(--border-color);\n  color: var(--text-muted);\n}\n\n.empty-transactions svg {\n  margin-bottom: 8px;\n  opacity: 0.5;\n}\n\n.empty-transactions p {\n  font-size: 13px;\n  margin: 0;\n}\n\n/* Metadata Block */\n.metadata-block {\n  background: #1e1e2e;\n  border-radius: 8px;\n  padding: 12px 16px;\n  overflow-x: auto;\n}\n\n.metadata-block pre {\n  margin: 0;\n  color: #cdd6f4;\n  font-family: \"JetBrains Mono\", \"Fira Code\", monospace;\n  font-size: 12px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Text color utilities */\n.text-success {\n  color: #10b981 !important;\n}\n\n.text-warning {\n  color: #f59e0b !important;\n}\n\n.text-error {\n  color: #ef4444 !important;\n}\n\n/* Small button icon */\n.btn-icon.small {\n  width: 24px;\n  height: 24px;\n  padding: 4px;\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.btn-icon.small:hover {\n  background: var(--bg-hover);\n  color: var(--text-primary);\n}\n\n/* Status Badge Large */\n.status-badge-large {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.status-badge-large.paid {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.status-badge-large.pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-badge-large.processing {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.status-badge-large.expired,\n.status-badge-large.failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status-badge-large.partially_paid {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n/* Responsive for session drawer */\n@media (max-width: 991px) {\n  .support-icon {\n    word-wrap: break-word;\n  }\n}\n\n@media (max-width: 520px) {\n  .session-status-banner {\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n  }\n\n  .detail-row {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .detail-key {\n    min-width: unset;\n  }\n\n  .detail-value {\n    text-align: left;\n    justify-content: flex-start;\n  }\n  .dashboard-layout:has(.test-mode-ribbon) .sidebar {\n    top: 0px;\n    height: calc(100vh - 0px);\n  }\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1; /* slate-300 */\n  border-radius: 9999px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8; /* slate-400 */\n}\n\nbody.modal-open {\n  overflow: hidden;\n  height: 100vh;\n}\n\n.support-icon {\n  font-size: smaller;\n}\n.mode-btn:hover {\n  background-color: #eef3ff;\n  border-color: #4f6df5;\n  color: #4f6df5;\n}\n\n.icon-btn-apidoc {\n  width: 75px;\n  height: 40px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.icon-btn-apidoc:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border-color: var(--text-muted);\n}\n\n.need-help {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n/* ---- Cloudflare Turnstile (auth forms) ---- */\n.turnstile-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 20px;\n  margin-top:10px;\n  min-height: 65px;\n}\n\n.turnstile-widget {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  max-width: 300px;\n}\n\n.turnstile-widget iframe {\n  max-width: 100%;\n}\n/* ─── Toast dismiss control (react-hot-toast) ─────────────────────────────\n   The library ships no close control, so toasts could only be waited out.\n   Rather than add a second X, AppToaster wraps the status icon on the left in\n   a button — this rule strips the button chrome so the icon looks exactly as\n   the library drew it, and only adds the hover/focus affordance that tells\n   people it is now clickable. */\n.toast-dismiss-icon {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: none;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.toast-dismiss-icon:hover {\n  opacity: 0.75;\n}\n\n.toast-dismiss-icon:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.9);\n  outline-offset: 2px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .toast-dismiss-icon {\n    transition: none;\n  }\n}\n\n/* ── DataTable: Quick Filters variant ─────────────────────────────────────\n   The same control the Transactions page uses, lifted out of that page's\n   <style jsx> block so any DataTable can opt into it with filterVariant=\"quick\".\n   Class names are prefixed .dtqf- rather than reusing .qf-: the Transactions\n   copy is emitted globally while that page is mounted, and two definitions of\n   the same selector would fight depending on which route was open. */\n.dt-quick-filter { position: relative; display: inline-flex; }\n\n.dtqf-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--line-strong, #dddfec);\n  border-radius: var(--r-sm, 10px);\n  background: var(--surface, #fff);\n  color: var(--t-700, #3b4059);\n  font: inherit;\n  font-size: 13.5px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n.dtqf-trigger:hover {\n  border-color: var(--brand-400, #a99cff);\n  color: var(--brand-700, #5847d6);\n}\n/* An active filter has to be visible from the closed state, or a merchant\n   wonders why the table is missing rows. */\n.dtqf-trigger.is-filtered {\n  border-color: var(--brand-600, #6d5df6);\n  background: var(--brand-100, #ece9ff);\n  color: var(--brand-700, #5847d6);\n  font-weight: 600;\n}\n.dtqf-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--brand-600, #6d5df6);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.dtqf-panel {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  z-index: 60;\n  min-width: 300px;\n  max-height: 40vh;\n  overflow-y: auto;\n  background: var(--surface, #fff);\n  border: 1px solid var(--line, #eaebf3);\n  border-radius: var(--r-md, 12px);\n  box-shadow: 0 12px 32px rgba(14, 17, 36, 0.14);\n}\n.dtqf-top {\n  position: sticky;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--line, #eaebf3);\n  background: var(--bg-inset, #eff0f8);\n  z-index: 9;\n}\n.dtqf-top-title { font-size: 12.5px; font-weight: 700; color: var(--ink, #0e1124); }\n.dtqf-reset {\n  border: none;\n  background: none;\n  padding: 2px 4px;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--accent, #6d5df6);\n  cursor: pointer;\n}\n.dtqf-reset:hover { text-decoration: underline; }\n\n.dtqf-section { padding: 6px; }\n.dtqf-header {\n  padding: 6px 8px 4px;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--t-500, #6c7189);\n}\n/* Subheading inside a section, for options that declare a `group`. */\n.dtqf-group {\n  padding: 8px 8px 3px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--t-400, #9aa0b6);\n}\n\n.dtqf-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px;\n  min-height: 36px;\n  border: none;\n  background: none;\n  border-radius: var(--r-sm, 10px);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--t-700, #3b4059);\n  cursor: pointer;\n  text-align: left;\n}\n.dtqf-item:hover { background: var(--bg-inset, #eff0f8); }\n/* Fixed slot for the tick: without it, selecting an item shifts every label\n   sideways and the list appears to jump. */\n.dtqf-check {\n  flex: none;\n  width: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent, #6d5df6);\n}\n.dtqf-label { flex: 1; }\n.dtqf-count {\n  flex: none;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--t-500, #6c7189);\n  background: var(--bg-inset, #eff0f8);\n  border-radius: 999px;\n  padding: 1px 8px;\n  font-variant-numeric: tabular-nums;\n}\n/* An option matching nothing stays selectable — picking it and seeing an empty\n   table is a real answer — but it should not read as equal to one that does. */\n.dtqf-item.is-empty { color: var(--t-400, #9aa0b6); }\n.dtqf-item.is-empty .dtqf-count { opacity: 0.65; }\n\n.dtqf-item.active {\n  background: var(--accent-soft, #ece9ff);\n  color: var(--accent-ink, #5847d6);\n  font-weight: 600;\n}\n.dtqf-item.active .dtqf-count { background: var(--surface, #fff); color: var(--accent-ink, #5847d6); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
